/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '../context/GsocApolloHooks';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {"context":{"apiName":"CURATED_API"}} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDateTime: { input: Date; output: Date; }
  AWSJSON: { input: unknown; output: unknown; }
  Long: { input: number; output: number; }
};

export type AwsDateTimeFilterInput = {
  readonly _eq?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _gt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _gte?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['AWSDateTime']['input']>>;
  readonly _lt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _lte?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _neq?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['AWSDateTime']['input']>>;
};

export type Aggregation = {
  readonly __typename?: 'Aggregation';
  readonly _avg: Scalars['Float']['output'];
  readonly _max: Scalars['Float']['output'];
  readonly _min: Scalars['Float']['output'];
  readonly _p1: Scalars['Float']['output'];
  readonly _p5: Scalars['Float']['output'];
  readonly _p25: Scalars['Float']['output'];
  readonly _p50: Scalars['Float']['output'];
  readonly _p75: Scalars['Float']['output'];
  readonly _p95: Scalars['Float']['output'];
  readonly _p99: Scalars['Float']['output'];
  readonly _stdDev: Scalars['Float']['output'];
  readonly _sum: Scalars['Float']['output'];
};

export enum AngleUnits {
  DegreeAngle = 'DEGREE_ANGLE',
  Radian = 'RADIAN'
}

export type BooleanFilterInput = {
  readonly _eq?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BusinessInsightsContact = {
  readonly __typename?: 'BusinessInsightsContact';
  /** The name of the antenna involved in the contact. */
  readonly antennaName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the contact. Acts as a primary key for this structure. */
  readonly contactId: Scalars['String']['output'];
  /** This represents the status of a contact. */
  readonly contactStatus: ContactStatus;
  /** This represents the AWS Customer ID which owns the contact. */
  readonly customerId: Scalars['String']['output'];
  /** This field represents which region(s) that data was delivered to. */
  readonly dataDeliveryRegions?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** A list of abstractions for how data is transferred within the service on behalf of the customer. */
  readonly dataflowList?: Maybe<ReadonlyArray<Dataflow>>;
  /** The end-time epoch of the contact. This does not include any post-pass time. This field acts as a secondary field for recording. That is, it is used when a time-partition of contacts is needed. (e.g. search, expiration, etc)  */
  readonly endTime: Scalars['AWSDateTime']['output'];
  /** The airport code associated with the ground station region being used. */
  readonly groundStationAirportCode?: Maybe<Scalars['String']['output']>;
  /** An abstraction for what location was primarily targeted for utilization */
  readonly groundStationName?: Maybe<Scalars['String']['output']>;
  /** Maximum elevation (degrees) */
  readonly maximumElevation?: Maybe<Elevation>;
  /** An abstraction for the expectations of the contact including dataflows and tracking. */
  readonly missionProfileArn?: Maybe<Scalars['String']['output']>;
  /** Post-pass time of the contact epoch in seconds. */
  readonly postPassEndTime?: Maybe<Scalars['AWSDateTime']['output']>;
  /** Pre-pass start time of the contact epoch in seconds. */
  readonly prePassStartTime?: Maybe<Scalars['AWSDateTime']['output']>;
  /** An abstraction for what was utilized in this contact. e.g. antenna, recordings, sdrs. This allows us to extend what entities were involved in a contact. */
  readonly reservationArns?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** An abstraction for the vehicle involved in the contact. */
  readonly satelliteArn?: Maybe<Scalars['String']['output']>;
  readonly schedulingRegion?: Maybe<Scalars['String']['output']>;
  /** The start time epoch of the contact. This does not include any pre-pass time. */
  readonly startTime: Scalars['AWSDateTime']['output'];
};

export enum ConfigCapabilityType {
  AntennaDownlink = 'ANTENNA_DOWNLINK',
  AntennaDownlinkDemodDecode = 'ANTENNA_DOWNLINK_DEMOD_DECODE',
  AntennaUplink = 'ANTENNA_UPLINK',
  ConnectionProxy = 'CONNECTION_PROXY',
  DataflowEndpoint = 'DATAFLOW_ENDPOINT',
  ManagedAntennaDownlinkDemodDecode = 'MANAGED_ANTENNA_DOWNLINK_DEMOD_DECODE',
  S3Playback = 'S3_PLAYBACK',
  S3Recording = 'S3_RECORDING',
  TelemetrySink = 'TELEMETRY_SINK',
  Tracking = 'TRACKING',
  UplinkEcho = 'UPLINK_ECHO'
}

export type ConfigIdToDagNodeMapEntry = {
  readonly __typename?: 'ConfigIdToDagNodeMapEntry';
  readonly key?: Maybe<Scalars['String']['output']>;
  readonly value?: Maybe<DagNode>;
};

export enum ContactEphemerisUsageType {
  DailyEphemerisRefreshPointingAngle = 'DAILY_EPHEMERIS_REFRESH_POINTING_ANGLE',
  DailyEphemerisRefreshValidateVisibility = 'DAILY_EPHEMERIS_REFRESH_VALIDATE_VISIBILITY',
  FinalPointingAngle = 'FINAL_POINTING_ANGLE',
  FinalPointingAngleReference = 'FINAL_POINTING_ANGLE_REFERENCE',
  Scheduling = 'SCHEDULING',
  UpdateContact = 'UPDATE_CONTACT'
}

export type ContactEphemerisUsageTypeFilterInput = {
  readonly _eq?: InputMaybe<ContactEphemerisUsageType>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<ContactEphemerisUsageType>>;
  readonly _neq?: InputMaybe<ContactEphemerisUsageType>;
  readonly _nin?: InputMaybe<ReadonlyArray<ContactEphemerisUsageType>>;
};

export type ContactGlobalDdbTableV2 = {
  readonly __typename?: 'ContactGlobalDDBTableV2';
  /** The customer-side AWS Account ID */
  readonly awsAccountId: Scalars['String']['output'];
  /** Reason for cancelling. */
  readonly cancellationReason?: Maybe<Scalars['String']['output']>;
  /** Cancellation timestamp of the record. Note originally in string format. */
  readonly cancellationTimestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  readonly capabilitiesToTest?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly configIdToDagNodeMap?: Maybe<ReadonlyArray<ConfigIdToDagNodeMapEntry>>;
  /** End time of the contact epoch in seconds. This does not include any postpass times. */
  readonly contactEndTimeEpochSeconds: Scalars['AWSDateTime']['output'];
  /** The contact identifier. */
  readonly contactId: Scalars['String']['output'];
  /** Start time of the contact epoch in seconds. This does not include any prepass times. */
  readonly contactStartTimeEpochSeconds: Scalars['AWSDateTime']['output'];
  /** Contact status */
  readonly contactStatus: ContactStatus;
  /** Contact type */
  readonly contactType: ContactType;
  /** Signature Map for the Contact */
  readonly createReservationForRegionSignatureMaps?: Maybe<Scalars['String']['output']>;
  /** Create timestamp of the record. Note originally in string format. */
  readonly createTimestamp: Scalars['AWSDateTime']['output'];
  /** AWS region of creation */
  readonly createdInRegion: Scalars['String']['output'];
  /** List storing EphemerisInfo objects storing info about the ephemeris used for scheduling, daily ephemeris refresh validate visibility or pointing angle, and final pointing angle calculations */
  readonly ephemerisInfoList?: Maybe<ReadonlyArray<EphemerisInfo>>;
  readonly failedToScheduleReasons?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The ground station ID */
  readonly groundStationId: Scalars['String']['output'];
  /** Maximum elevation (degrees) */
  readonly maxElevationDegrees: Scalars['Float']['output'];
  /** Metering Archive ID */
  readonly meteringArchiveId?: Maybe<Scalars['String']['output']>;
  /** Metering Status */
  readonly meteringStatus?: Maybe<MeteringStatus>;
  /** Metering Archive ID */
  readonly meteringUsage?: Maybe<MeteringUsage>;
  /** Migration version. */
  readonly migrationVersion?: Maybe<Scalars['Int']['output']>;
  /** Mission Profile AWS Resource Name */
  readonly missionProfileArn: Scalars['String']['output'];
  readonly obsoleteReservationArnList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Payer Token */
  readonly payerToken?: Maybe<Scalars['String']['output']>;
  /** Post-pass time of the contact epoch in seconds. */
  readonly postPassEndTimeEpochSeconds: Scalars['AWSDateTime']['output'];
  /** Pre-pass start time of the contact epoch in seconds. */
  readonly prePassStartTimeEpochSeconds: Scalars['AWSDateTime']['output'];
  /** Rescheduling timestamp of the record. Note originally in string format. */
  readonly reschedulingTimestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  readonly reservationArnList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Reserve Contact Step Function ID */
  readonly reserveContactStepFunctionId: Scalars['String']['output'];
  /** Satellite AWS Resource Name */
  readonly satelliteArn?: Maybe<Scalars['String']['output']>;
  /** Signature Map for the Contact */
  readonly signatureMap?: Maybe<Scalars['String']['output']>;
  /** AWS region of creation */
  readonly targetRegion: Scalars['String']['output'];
  /** List of RouteIds created in CapTel Routing Service for telemetry delivery */
  readonly telemetryRouteList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Update timestamp of the record. Note originally in string format. */
  readonly updateTimestamp?: Maybe<Scalars['AWSDateTime']['output']>;
  /** Version number of the record. */
  readonly versionNumber: Scalars['Int']['output'];
  /** Version timestamp of the record. */
  readonly versionTimestamp?: Maybe<Scalars['AWSDateTime']['output']>;
};

export enum ContactStatus {
  Available = 'AVAILABLE',
  AwsCancelled = 'AWS_CANCELLED',
  AwsFailed = 'AWS_FAILED',
  Cancelled = 'CANCELLED',
  Cancelling = 'CANCELLING',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  FailedToSchedule = 'FAILED_TO_SCHEDULE',
  Pass = 'PASS',
  Postpass = 'POSTPASS',
  Prepass = 'PREPASS',
  Rescheduling = 'RESCHEDULING',
  Scheduled = 'SCHEDULED',
  Scheduling = 'SCHEDULING'
}

export type ContactStatusFilterInput = {
  readonly _eq?: InputMaybe<ContactStatus>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<ContactStatus>>;
  readonly _neq?: InputMaybe<ContactStatus>;
  readonly _nin?: InputMaybe<ReadonlyArray<ContactStatus>>;
};

export type ContactTable = {
  readonly __typename?: 'ContactTable';
  /** Populated only when sk=CONSUMER-BUSINESS-INSIGHTS-CONTACT */
  readonly businessInsightsContact?: Maybe<BusinessInsightsContact>;
  /** Populated only when sk=SOURCE-KINESIS-CP-CONTACTGLOBALDDBTABLEV2 */
  readonly contactGlobalDDBTableV2Dto?: Maybe<ContactGlobalDdbTableV2>;
  /** time to live attribute */
  readonly datalakeTtl: Scalars['AWSDateTime']['output'];
  /** Populated only when sk=SOURCE_KINESIS_CP_INREGIONCONTACTDDBTABLE */
  readonly inRegionContactDdbTable?: Maybe<InRegionContactDdbTable>;
  /** pk = Primary Key = Contact ID */
  readonly pk: Scalars['String']['output'];
  /** sk = Sort Key = ContactTableSources Enum */
  readonly sk: Scalars['String']['output'];
  /** Version Attribute used for optimistic locking. */
  readonly version?: Maybe<Scalars['Int']['output']>;
};

export enum ContactType {
  AntennaSpecific = 'ANTENNA_SPECIFIC',
  GroundStationSpecific = 'GROUND_STATION_SPECIFIC'
}

export type CpContactEvent010 = {
  readonly __typename?: 'CpContactEvent010';
  /** The unique identifier associated with Contacts. This can be used to unambiguously fetch a Contact. */
  readonly contactId: Scalars['String']['output'];
  /** The status of the contact. Provided here to support improved event filtering. */
  readonly contactStatus: Scalars['String']['output'];
  /** The name part of the customer associated with the contact. Provided here to support improved event filtering. */
  readonly customerNamePart: Scalars['String']['output'];
};

export enum CpCriticality {
  Preferred = 'PREFERRED',
  Removed = 'REMOVED',
  Required = 'REQUIRED'
}

export enum CpDataflowType {
  Dds = 'DDS',
  DdsV2 = 'DDS_V2'
}

export type CursorPart = {
  readonly __typename?: 'CursorPart';
  readonly key: Scalars['String']['output'];
  readonly value: Scalars['String']['output'];
};

export type CursorPartInput = {
  readonly key: Scalars['String']['input'];
  readonly value: Scalars['String']['input'];
};

export type DagNode = {
  readonly __typename?: 'DagNode';
  /** ID of the config that this DAGNode is representing. */
  readonly configId: Scalars['String']['output'];
  /** Version to uniquely identify nodes as well as paths from source to end */
  readonly dagNodeSemanticVersion?: Maybe<Scalars['String']['output']>;
  /** If this config is a dataflow endpoint, this is endpoint details. If this config is not a dataflow endpoint this will be null. */
  readonly dataflowEndpointDetails?: Maybe<Scalars['String']['output']>;
  /** If this config is a dataflow endpoint, this is the config ID of the antenna resource for that dataflow. This is needed for generating the execution context and for executing dataflow endpoint reservations. If this config is not a dataflow endpoint this will be null. */
  readonly dataflowSourceConfigId?: Maybe<Scalars['String']['output']>;
  /** Dataflow UUID */
  readonly dataflowUuid?: Maybe<Scalars['String']['output']>;
  /** Id of the execution context for fulfilling this config */
  readonly executionContextId?: Maybe<Scalars['String']['output']>;
  /** matchedCapabilityArns */
  readonly matchedCapabilityArns?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** If this config is a dataflow endpoint, this is the config ID of the antenna resource for that dataflow. This is needed for generating the execution context and for executing dataflow endpoint reservations. If this config is not a dataflow endpoint this will be null. */
  readonly nodeConfigCapabilityType?: Maybe<ConfigCapabilityType>;
  /** A single config may be connected to multiple other configs if the config has multiple output types (for example, a demod decode mission profile will have output types in the dataflows). This maps an output type to the next config ID that it's connected to */
  readonly outputTypeToNextConfigIdsMap?: Maybe<ReadonlyArray<StringToStringMapEntry>>;
  /** A single config may be connected to multiple other configs if the config has multiple output types (for example, a demod decode mission profile will have output types in the dataflows) This maps an output type to the previous config ID that it's connected to */
  readonly outputTypeToPreviousConfigIdsMap?: Maybe<ReadonlyArray<StringToStringMapEntry>>;
  /** Region where this config needs to be reserved */
  readonly region?: Maybe<Scalars['String']['output']>;
  /** Id of the reservation for capability fulfilling this config */
  readonly reservationId?: Maybe<Scalars['String']['output']>;
  /** Status of the reservation for this Node. If no reservation has been created yet this will be null. */
  readonly reservationStatus?: Maybe<ReservationStatus>;
  /** Arn of the capability that is being reserved for this config */
  readonly reservedCapabilityArn?: Maybe<Scalars['String']['output']>;
  /** If this config is a S3 endpoint, this is endpoint details. If this config is not a S3 endpoint this will be null. */
  readonly s3RecordingDetails?: Maybe<Scalars['String']['output']>;
  /** Set of config IDs that must share the same reservation group as this config */
  readonly sameReservationGroupAsConfigIds?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** VITA 49.2 Stream ID - Id embedded in the vita 49 packet.  Stream ids flow from source to end without changing. */
  readonly vita49StreamId?: Maybe<Scalars['Int']['output']>;
};

export type Dataflow = {
  readonly __typename?: 'Dataflow';
  readonly dataflowId?: Maybe<Scalars['String']['output']>;
  readonly dataflowMetrics?: Maybe<DataflowMetrics>;
  readonly destinationNode?: Maybe<DataflowNode>;
  readonly rfCharacteristics?: Maybe<RfCharacteristics>;
  readonly sourceNode?: Maybe<DataflowNode>;
  readonly tags?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly vita49StreamCharacteristics?: Maybe<Vita49StreamCharacteristics>;
};

export type DataflowMetrics = {
  readonly __typename?: 'DataflowMetrics';
  /** The number of encapsulated bytes that the destination node of the dataflow received. Compare with bytes transferred to gauge customer experience. */
  readonly bytesReceived?: Maybe<Scalars['Long']['output']>;
  /** The number of encapsulated bytes that the source node of the dataflow transferred. */
  readonly bytesTransferred?: Maybe<Scalars['Long']['output']>;
};

export type DataflowNode = {
  readonly __typename?: 'DataflowNode';
  /** This would be the capabilityArn */
  readonly nodeArn?: Maybe<Scalars['String']['output']>;
  readonly nodeRegion?: Maybe<Scalars['String']['output']>;
  readonly nodeType?: Maybe<ConfigCapabilityType>;
};

export type DataflowTranslation = {
  readonly __typename?: 'DataflowTranslation';
  readonly egress?: Maybe<TranslationDetail>;
  readonly ingress?: Maybe<TranslationDetail>;
};

export type DataflowTranslationFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<DataflowTranslationFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<DataflowTranslationFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<DataflowTranslationFilterInput>>;
  readonly egress?: InputMaybe<TranslationDetailFilterInput>;
  readonly ingress?: InputMaybe<TranslationDetailFilterInput>;
};

export enum DeliveryMechanism {
  Ddx = 'DDX',
  LaminarFlow = 'LAMINAR_FLOW'
}

export type DeliveryMechanismFilterInput = {
  readonly _eq?: InputMaybe<DeliveryMechanism>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<DeliveryMechanism>>;
  readonly _neq?: InputMaybe<DeliveryMechanism>;
  readonly _nin?: InputMaybe<ReadonlyArray<DeliveryMechanism>>;
};

export type DereferencedMissionProfileData = {
  readonly __typename?: 'DereferencedMissionProfileData';
  readonly createdInRegion?: Maybe<Scalars['String']['output']>;
  readonly customerAwsAccountId?: Maybe<Scalars['String']['output']>;
  readonly minimumViableContactSeconds?: Maybe<Scalars['Int']['output']>;
  readonly missionProfileArn?: Maybe<Scalars['String']['output']>;
  readonly missionProfileId?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly postPassDurationSeconds?: Maybe<Scalars['Int']['output']>;
  readonly prePassDurationSeconds?: Maybe<Scalars['Int']['output']>;
  readonly telemetrySinkConfigArn?: Maybe<Scalars['String']['output']>;
  readonly trackingConfigArn?: Maybe<Scalars['String']['output']>;
};

export type Elevation = {
  readonly __typename?: 'Elevation';
  readonly unit: AngleUnits;
  readonly value: Scalars['Float']['output'];
};

export type EphemerisInfo = {
  readonly __typename?: 'EphemerisInfo';
  /** Unique identifier for the ephemeris */
  readonly ephemerisId: Scalars['String']['output'];
  /** Type of ephemeris */
  readonly ephemerisSourceType?: Maybe<EphemerisSourceType>;
  /** Timestamp when the ephemeris was updated */
  readonly updateTime: Scalars['AWSDateTime']['output'];
  /** Type of ephemeris usage */
  readonly usageType: ContactEphemerisUsageType;
};

export type EphemerisInfoFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<EphemerisInfoFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<EphemerisInfoFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<EphemerisInfoFilterInput>>;
  readonly ephemerisId?: InputMaybe<StringFilterInput>;
  readonly ephemerisSourceType?: InputMaybe<EphemerisSourceTypeFilterInput>;
  readonly updateTime?: InputMaybe<TimestampFilterInput>;
  readonly usageType?: InputMaybe<ContactEphemerisUsageTypeFilterInput>;
};

export enum EphemerisSourceType {
  AzEl = 'AZ_EL',
  Oem = 'OEM',
  ServiceManaged = 'SERVICE_MANAGED',
  Tle = 'TLE'
}

export type EphemerisSourceTypeFilterInput = {
  readonly _eq?: InputMaybe<EphemerisSourceType>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<EphemerisSourceType>>;
  readonly _neq?: InputMaybe<EphemerisSourceType>;
  readonly _nin?: InputMaybe<ReadonlyArray<EphemerisSourceType>>;
};

export type FloatFilterInput = {
  readonly _eq?: InputMaybe<Scalars['Float']['input']>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _gt?: InputMaybe<Scalars['Float']['input']>;
  readonly _gte?: InputMaybe<Scalars['Float']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['Float']['input']>>;
  readonly _lt?: InputMaybe<Scalars['Float']['input']>;
  readonly _lte?: InputMaybe<Scalars['Float']['input']>;
  readonly _neq?: InputMaybe<Scalars['Float']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['Float']['input']>>;
};

export type Frequency = {
  readonly __typename?: 'Frequency';
  readonly units?: Maybe<Scalars['String']['output']>;
  readonly value?: Maybe<Scalars['Float']['output']>;
};

export enum FrequencyBand {
  KaBand = 'KA_BAND',
  None = 'NONE',
  SBand = 'S_BAND',
  XBand = 'X_BAND'
}

export type GetGsocContactV2Input = {
  readonly contactId?: InputMaybe<Scalars['String']['input']>;
};

export type GsocAntennaDemodDecodeDetails = {
  readonly __typename?: 'GsocAntennaDemodDecodeDetails';
  readonly decodeConfigData: GsocDecodeConfigData;
  readonly demodulationConfigData: GsocDemodulationConfigData;
  readonly rfCharacteristics: GsocRfCharacteristics;
};

export type GsocAntennaDemodDecodeDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocAntennaDemodDecodeDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocAntennaDemodDecodeDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocAntennaDemodDecodeDetailsFilterInput>>;
  readonly decodeConfigData?: InputMaybe<GsocDecodeConfigDataFilterInput>;
  readonly demodulationConfigData?: InputMaybe<GsocDemodulationConfigDataFilterInput>;
  readonly rfCharacteristics?: InputMaybe<GsocRfCharacteristicsFilterInput>;
};

export type GsocAntennaDownlinkDetails = {
  readonly __typename?: 'GsocAntennaDownlinkDetails';
  readonly rfCharacteristics: GsocRfCharacteristics;
};

export type GsocAntennaDownlinkDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocAntennaDownlinkDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocAntennaDownlinkDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocAntennaDownlinkDetailsFilterInput>>;
  readonly rfCharacteristics?: InputMaybe<GsocRfCharacteristicsFilterInput>;
};

export type GsocAwsTemporaryCredentials = {
  readonly __typename?: 'GsocAwsTemporaryCredentials';
  readonly accessKeyId: Scalars['String']['output'];
  readonly expiration: Scalars['AWSDateTime']['output'];
  readonly secretAccessKey: Scalars['String']['output'];
  readonly sessionToken: Scalars['String']['output'];
};

export type GsocCapability = {
  readonly __typename?: 'GsocCapability';
  readonly arn?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
};

export type GsocCapabilityV2 = {
  readonly __typename?: 'GsocCapabilityV2';
  readonly arn?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly plots: ReadonlyArray<NamedImageV2>;
  readonly type: Scalars['String']['output'];
};

export type GsocCapabilityV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocCapabilityV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocCapabilityV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocCapabilityV2FilterInput>>;
  readonly arn?: InputMaybe<StringFilterInput>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly plots?: InputMaybe<NamedImageV2FilterInput>;
  readonly type?: InputMaybe<StringFilterInput>;
};

export type GsocConfig = {
  readonly __typename?: 'GsocConfig';
  readonly arn?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
};

export type GsocConfigFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocConfigFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocConfigFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocConfigFilterInput>>;
  readonly arn?: InputMaybe<StringFilterInput>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly type?: InputMaybe<StringFilterInput>;
};

export type GsocConnectionProxyDetails = {
  readonly __typename?: 'GsocConnectionProxyDetails';
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowTranslation?: Maybe<DataflowTranslation>;
};

export type GsocConnectionProxyDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocConnectionProxyDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocConnectionProxyDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocConnectionProxyDetailsFilterInput>>;
  readonly configArn?: InputMaybe<StringFilterInput>;
  readonly dataflowTranslation?: InputMaybe<DataflowTranslationFilterInput>;
};

export type GsocContactDetails = {
  readonly __typename?: 'GsocContactDetails';
  /** Active contact version id for the contact */
  readonly activeContactVersionId?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the contact */
  readonly contactId: Scalars['String']['output'];
  /** Current status of the contact. */
  readonly contactStatus: ContactStatus;
  /** Customer information for the contact. */
  readonly customer: GsocCustomer;
  /** List of dataflows and their detailed information */
  readonly dataflows?: Maybe<ReadonlyArray<GsocDataflow>>;
  /** time to live attribute */
  readonly datalakeTtl?: Maybe<Scalars['AWSDateTime']['output']>;
  /** List of regions where the contact data will land. */
  readonly destinationRegions: ReadonlyArray<Scalars['String']['output']>;
  /** Duration of the contact, in milliseconds */
  readonly durationMs: Scalars['Float']['output'];
  /** List storing EphemerisInfo objects storing info about the ephemeris used for scheduling, daily ephemeris refresh validate visibility or pointing angle, and reference/actual final pointing angle calculations */
  readonly ephemerisInfoList?: Maybe<ReadonlyArray<EphemerisInfo>>;
  /** Failed to schedule reason */
  readonly failedToScheduleReasons?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Ground Stations. */
  readonly groundStations?: Maybe<ReadonlyArray<GsocGroundStation>>;
  /** Configuration information from the Mission Profile at contact scheduling time. */
  readonly missionProfile: GsocMissionProfile;
  /** Unique identifier for the contact */
  readonly pk: Scalars['String']['output'];
  /** Satellite associated with the contact. */
  readonly satellite?: Maybe<GsocSatellite>;
  /** Region that the contact was scheduled from */
  readonly schedulingRegion: Scalars['String']['output'];
  /** Signature map containing troubleshooting information relevant to the contact. */
  readonly signatureMap?: Maybe<ReadonlyArray<SignatureMapEntry>>;
  /** List of tags for tagging contacts for search purposes */
  readonly tags?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** List of RouteIds created in CapTel Routing Service for telemetry delivery */
  readonly telemetryRouteList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The time range of the contact */
  readonly timeRange: TimeRange;
};

export type GsocContactDynamoDbTable = {
  readonly __typename?: 'GsocContactDynamoDbTable';
  /** Active contact version id for the contact */
  readonly activeContactVersionId?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the contact */
  readonly contactId: Scalars['String']['output'];
  /** Current status of the contact. */
  readonly contactStatus: ContactStatus;
  /** Customer information for the contact. */
  readonly customer: GsocCustomer;
  /** List of dataflows and their detailed information */
  readonly dataflows?: Maybe<ReadonlyArray<GsocDataflow>>;
  /** time to live attribute */
  readonly datalakeTtl?: Maybe<Scalars['AWSDateTime']['output']>;
  /** List of regions where the contact data will land. */
  readonly destinationRegions: ReadonlyArray<Scalars['String']['output']>;
  /** Duration of the contact, in milliseconds */
  readonly durationMs: Scalars['Float']['output'];
  /** List storing EphemerisInfo objects storing info about the ephemeris used for scheduling, daily ephemeris refresh validate visibility or pointing angle, and reference/actual final pointing angle calculations */
  readonly ephemerisInfoList?: Maybe<ReadonlyArray<EphemerisInfo>>;
  /** Failed to schedule reason */
  readonly failedToScheduleReasons?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Ground Stations. */
  readonly groundStations?: Maybe<ReadonlyArray<GsocGroundStation>>;
  /** Configuration information from the Mission Profile at contact scheduling time. */
  readonly missionProfile: GsocMissionProfile;
  /** Unique identifier for the contact */
  readonly pk: Scalars['String']['output'];
  /** Satellite associated with the contact. */
  readonly satellite?: Maybe<GsocSatellite>;
  /** Region that the contact was scheduled from */
  readonly schedulingRegion: Scalars['String']['output'];
  /** Signature map containing troubleshooting information relevant to the contact. */
  readonly signatureMap?: Maybe<ReadonlyArray<SignatureMapEntry>>;
  /** List of tags for tagging contacts for search purposes */
  readonly tags?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** List of RouteIds created in CapTel Routing Service for telemetry delivery */
  readonly telemetryRouteList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The time range of the contact */
  readonly timeRange: TimeRange;
};

export type GsocContactEvent010 = {
  readonly __typename?: 'GsocContactEvent010';
  /** The unique identifier associated with Contacts. This can be used to unambiguously fetch a Contact. */
  readonly contactId?: Maybe<Scalars['String']['output']>;
};

export type GsocContactIndexOpenSearch = {
  readonly __typename?: 'GsocContactIndexOpenSearch';
  /** Active contact version id for the contact */
  readonly activeContactVersionId?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the contact */
  readonly contactId: Scalars['String']['output'];
  /** Current status of the contact. */
  readonly contactStatus: ContactStatus;
  /** Customer information for the contact. */
  readonly customer: GsocCustomer;
  /** List of dataflows and their detailed information */
  readonly dataflows?: Maybe<ReadonlyArray<GsocDataflow>>;
  /** time to live attribute */
  readonly datalakeTtl?: Maybe<Scalars['AWSDateTime']['output']>;
  /** List of regions where the contact data will land. */
  readonly destinationRegions: ReadonlyArray<Scalars['String']['output']>;
  /** Duration of the contact, in milliseconds */
  readonly durationMs: Scalars['Float']['output'];
  /** List storing EphemerisInfo objects storing info about the ephemeris used for scheduling, daily ephemeris refresh validate visibility or pointing angle, and reference/actual final pointing angle calculations */
  readonly ephemerisInfoList?: Maybe<ReadonlyArray<EphemerisInfo>>;
  /** Failed to schedule reason */
  readonly failedToScheduleReasons?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Ground Stations. */
  readonly groundStations?: Maybe<ReadonlyArray<GsocGroundStation>>;
  /** Configuration information from the Mission Profile at contact scheduling time. */
  readonly missionProfile: GsocMissionProfile;
  /** Unique identifier for the contact */
  readonly pk: Scalars['String']['output'];
  /** Satellite associated with the contact. */
  readonly satellite?: Maybe<GsocSatellite>;
  /** Region that the contact was scheduled from */
  readonly schedulingRegion: Scalars['String']['output'];
  /** Signature map containing troubleshooting information relevant to the contact. */
  readonly signatureMap?: Maybe<ReadonlyArray<SignatureMapEntry>>;
  /** List of tags for tagging contacts for search purposes */
  readonly tags?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** List of RouteIds created in CapTel Routing Service for telemetry delivery */
  readonly telemetryRouteList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The time range of the contact */
  readonly timeRange: TimeRange;
};

export type GsocContactStatusFilterInput = {
  readonly _eq?: InputMaybe<ContactStatus>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<ContactStatus>>;
  readonly _neq?: InputMaybe<ContactStatus>;
  readonly _nin?: InputMaybe<ReadonlyArray<ContactStatus>>;
};

export type GsocContactV2 = {
  readonly __typename?: 'GsocContactV2';
  /** Active contact version id for the contact */
  readonly activeContactVersionId?: Maybe<Scalars['Int']['output']>;
  /** ACU report */
  readonly acuPlots?: Maybe<S3Object>;
  /** Unique identifier for the contact */
  readonly contactId: Scalars['String']['output'];
  /** Antenna-level postpass plots (ACU, VTR, etc.) */
  readonly contactPlots?: Maybe<ReadonlyArray<NamedImageV2>>;
  /** Current status of the contact. */
  readonly contactStatus: ContactStatus;
  /** Customer information for the contact. */
  readonly customer: GsocCustomer;
  /** List of dataflows and their detailed information */
  readonly dataflows?: Maybe<ReadonlyArray<GsocDataflowV2>>;
  /** time to live attribute */
  readonly datalakeTtl?: Maybe<Scalars['AWSDateTime']['output']>;
  /** List of regions where the contact data will land. */
  readonly destinationRegions: ReadonlyArray<Scalars['String']['output']>;
  /** Duration of the contact, in milliseconds */
  readonly durationMs: Scalars['Float']['output'];
  /** List storing EphemerisInfo objects storing info about the ephemeris used for scheduling, daily ephemeris refresh validate visibility or pointing angle, and reference/actual final pointing angle calculations */
  readonly ephemerisInfoList?: Maybe<ReadonlyArray<EphemerisInfo>>;
  /** Failed to schedule reason */
  readonly failedToScheduleReasons?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** Ground Stations. */
  readonly groundStations?: Maybe<ReadonlyArray<GsocGroundStation>>;
  /** Configuration information from the Mission Profile at contact scheduling time. */
  readonly missionProfile: GsocMissionProfile;
  /** Unique identifier for the contact */
  readonly pk: Scalars['String']['output'];
  /** Satellite associated with the contact. */
  readonly satellite?: Maybe<GsocSatellite>;
  /** Region that the contact was scheduled from */
  readonly schedulingRegion: Scalars['String']['output'];
  /** Signature map containing troubleshooting information relevant to the contact. */
  readonly signatureMap?: Maybe<ReadonlyArray<SignatureMapEntry>>;
  /** List of tags for tagging contacts for search purposes */
  readonly tags?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** List of RouteIds created in CapTel Routing Service for telemetry delivery */
  readonly telemetryRouteList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  /** The time range of the contact */
  readonly timeRange: TimeRange;
};

export type GsocContactV2Aggregation = {
  readonly __typename?: 'GsocContactV2Aggregation';
  readonly activeContactVersionId: Aggregation;
  readonly durationMs: Aggregation;
  readonly satellite: GsocSatelliteAggregation;
};

export type GsocContactV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocContactV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocContactV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocContactV2FilterInput>>;
  readonly activeContactVersionId?: InputMaybe<IntegerFilterInput>;
  readonly acuPlots?: InputMaybe<S3ObjectFilterInput>;
  readonly contactId?: InputMaybe<StringFilterInput>;
  readonly contactPlots?: InputMaybe<NamedImageV2FilterInput>;
  readonly contactStatus?: InputMaybe<ContactStatusFilterInput>;
  readonly customer?: InputMaybe<GsocCustomerFilterInput>;
  readonly dataflows?: InputMaybe<GsocDataflowV2FilterInput>;
  readonly datalakeTtl?: InputMaybe<TimestampFilterInput>;
  readonly destinationRegions?: InputMaybe<StringFilterInput>;
  readonly durationMs?: InputMaybe<FloatFilterInput>;
  readonly ephemerisInfoList?: InputMaybe<EphemerisInfoFilterInput>;
  readonly failedToScheduleReasons?: InputMaybe<StringFilterInput>;
  readonly groundStations?: InputMaybe<GsocGroundStationFilterInput>;
  readonly missionProfile?: InputMaybe<GsocMissionProfileFilterInput>;
  readonly pk?: InputMaybe<StringFilterInput>;
  readonly satellite?: InputMaybe<GsocSatelliteFilterInput>;
  readonly schedulingRegion?: InputMaybe<StringFilterInput>;
  readonly signatureMap?: InputMaybe<SignatureMapFilterInput>;
  readonly tags?: InputMaybe<StringFilterInput>;
  readonly telemetryRouteList?: InputMaybe<StringFilterInput>;
  readonly timeRange?: InputMaybe<TimeRangeFilterInput>;
};

export type GsocContactV2SortInput = {
  readonly activeContactVersionId?: InputMaybe<SortOrder>;
  readonly acuPlots?: InputMaybe<S3ObjectSortInput>;
  readonly contactId?: InputMaybe<SortOrder>;
  readonly contactStatus?: InputMaybe<SortOrder>;
  readonly customer?: InputMaybe<GsocCustomerSortInput>;
  readonly datalakeTtl?: InputMaybe<SortOrder>;
  readonly durationMs?: InputMaybe<SortOrder>;
  readonly missionProfile?: InputMaybe<GsocMissionProfileSortInput>;
  readonly pk?: InputMaybe<SortOrder>;
  readonly satellite?: InputMaybe<GsocSatelliteSortInput>;
  readonly schedulingRegion?: InputMaybe<SortOrder>;
  readonly timeRange?: InputMaybe<TimeRangeSortInput>;
};

export type GsocCustomer = {
  readonly __typename?: 'GsocCustomer';
  readonly awsAccountId?: Maybe<Scalars['String']['output']>;
  readonly awsGsaasAwsAccountNamePart: Scalars['String']['output'];
  readonly external: Scalars['Boolean']['output'];
};

export type GsocCustomerFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocCustomerFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocCustomerFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocCustomerFilterInput>>;
  readonly awsAccountId?: InputMaybe<GsocStringFilterInput>;
  readonly awsGsaasAwsAccountNamePart?: InputMaybe<GsocStringFilterInput>;
  readonly external?: InputMaybe<BooleanFilterInput>;
};

export type GsocCustomerSortInput = {
  readonly awsAccountId?: InputMaybe<SortOrder>;
  readonly awsGsaasAwsAccountNamePart?: InputMaybe<SortOrder>;
  readonly external?: InputMaybe<SortOrder>;
};

export type GsocDataflow = {
  readonly __typename?: 'GsocDataflow';
  readonly dataflowId: Scalars['String']['output'];
  readonly destination: GsocNode;
  readonly source: GsocNode;
  readonly tags: ReadonlyArray<Scalars['String']['output']>;
};

export type GsocDataflowV2 = {
  readonly __typename?: 'GsocDataflowV2';
  readonly dataflowId: Scalars['String']['output'];
  readonly destination: GsocNodeV2;
  readonly source: GsocNodeV2;
  readonly tags: ReadonlyArray<Scalars['String']['output']>;
};

export type GsocDataflowV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocDataflowV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocDataflowV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocDataflowV2FilterInput>>;
  readonly dataflowId?: InputMaybe<StringFilterInput>;
  readonly destination?: InputMaybe<GsocNodeV2FilterInput>;
  readonly source?: InputMaybe<GsocNodeV2FilterInput>;
  readonly tags?: InputMaybe<StringFilterInput>;
};

export enum GsocDataplaneType {
  DataDefender = 'DATA_DEFENDER',
  LaminarFlow = 'LAMINAR_FLOW'
}

export type GsocDataplaneTypeFilterInput = {
  readonly _eq?: InputMaybe<GsocDataplaneType>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<GsocDataplaneType>>;
  readonly _neq?: InputMaybe<GsocDataplaneType>;
  readonly _nin?: InputMaybe<ReadonlyArray<GsocDataplaneType>>;
};

export type GsocDecodeConfigData = {
  readonly __typename?: 'GsocDecodeConfigData';
  readonly unvalidatedJson: Scalars['String']['output'];
};

export type GsocDecodeConfigDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocDecodeConfigDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocDecodeConfigDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocDecodeConfigDataFilterInput>>;
  readonly unvalidatedJson?: InputMaybe<StringFilterInput>;
};

export type GsocDemodulationConfigData = {
  readonly __typename?: 'GsocDemodulationConfigData';
  readonly unvalidatedJson: Scalars['String']['output'];
};

export type GsocDemodulationConfigDataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocDemodulationConfigDataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocDemodulationConfigDataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocDemodulationConfigDataFilterInput>>;
  readonly unvalidatedJson?: InputMaybe<StringFilterInput>;
};

export type GsocGetContactDetailsInput = {
  readonly date?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly id: Scalars['String']['input'];
};

export type GsocGroundStation = {
  readonly __typename?: 'GsocGroundStation';
  readonly antennaName?: Maybe<Scalars['String']['output']>;
  readonly groundStationId: Scalars['String']['output'];
  readonly groundStationName: Scalars['String']['output'];
  readonly region: Scalars['String']['output'];
};

export type GsocGroundStationFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocGroundStationFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocGroundStationFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocGroundStationFilterInput>>;
  readonly antennaName?: InputMaybe<GsocStringFilterInput>;
  readonly groundStationId?: InputMaybe<GsocStringFilterInput>;
  readonly groundStationName?: InputMaybe<GsocStringFilterInput>;
  readonly region?: InputMaybe<GsocStringFilterInput>;
};

export type GsocIamRole = {
  readonly __typename?: 'GsocIamRole';
  readonly awsTemporaryCredentials?: Maybe<GsocAwsTemporaryCredentials>;
  readonly isAuthorized: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly roleArn: Scalars['String']['output'];
};

export type GsocIntegerRange = {
  readonly __typename?: 'GsocIntegerRange';
  readonly maximum: Scalars['Int']['output'];
  readonly minimum: Scalars['Int']['output'];
};

export type GsocIntegerRangeFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocIntegerRangeFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocIntegerRangeFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocIntegerRangeFilterInput>>;
  readonly maximum?: InputMaybe<IntegerFilterInput>;
  readonly minimum?: InputMaybe<IntegerFilterInput>;
};

export type GsocListContactsPaginatedInput = {
  readonly cursor?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly limit?: InputMaybe<Scalars['Int']['input']>;
  readonly sort?: InputMaybe<ReadonlyArray<ListGsocContactsSortInput>>;
  readonly where?: InputMaybe<ListGsocContactsFilterInput>;
};

export type GsocListContactsPaginatedOutput = {
  readonly __typename?: 'GsocListContactsPaginatedOutput';
  readonly contacts: ReadonlyArray<GsocContactDetails>;
  readonly pageInfo: GsocPageInfo;
};

export type GsocListIamRolesOutput = {
  readonly __typename?: 'GsocListIamRolesOutput';
  readonly roles: ReadonlyArray<GsocIamRole>;
};

export type GsocManagedAntennaDemodDecodeDetails = {
  readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails';
  readonly managedRadioConfigId: Scalars['String']['output'];
  readonly rfCharacteristics: GsocRfCharacteristics;
};

export type GsocManagedAntennaDemodDecodeDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocManagedAntennaDemodDecodeDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocManagedAntennaDemodDecodeDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocManagedAntennaDemodDecodeDetailsFilterInput>>;
  readonly managedRadioConfigId?: InputMaybe<StringFilterInput>;
  readonly rfCharacteristics?: InputMaybe<GsocRfCharacteristicsFilterInput>;
};

export type GsocMissionProfile = {
  readonly __typename?: 'GsocMissionProfile';
  readonly missionProfileArn?: Maybe<Scalars['String']['output']>;
  readonly missionProfileId: Scalars['String']['output'];
  readonly missionProfileName?: Maybe<Scalars['String']['output']>;
};

export type GsocMissionProfileFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocMissionProfileFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocMissionProfileFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocMissionProfileFilterInput>>;
  readonly missionProfileArn?: InputMaybe<GsocStringFilterInput>;
  readonly missionProfileId?: InputMaybe<GsocStringFilterInput>;
  readonly missionProfileName?: InputMaybe<GsocStringFilterInput>;
};

export type GsocMissionProfileSortInput = {
  readonly missionProfileArn?: InputMaybe<SortOrder>;
  readonly missionProfileId?: InputMaybe<SortOrder>;
  readonly missionProfileName?: InputMaybe<SortOrder>;
};

export type GsocNode = {
  readonly __typename?: 'GsocNode';
  readonly capability: GsocCapability;
  readonly config: GsocConfig;
  readonly nodeDetails: GsocNodeDetails;
  readonly region: Scalars['String']['output'];
  readonly telemetryInfo?: Maybe<GsocTelemetryInformation>;
};

export type GsocNodeAgentDetails = {
  readonly __typename?: 'GsocNodeAgentDetails';
  readonly version?: Maybe<Scalars['String']['output']>;
};

export type GsocNodeAgentDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocNodeAgentDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocNodeAgentDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocNodeAgentDetailsFilterInput>>;
  readonly version?: InputMaybe<StringFilterInput>;
};

export type GsocNodeDataplaneDataDefenderDetails = {
  readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails';
  readonly dataDeliveryServiceDestinationArn?: Maybe<Scalars['String']['output']>;
  readonly dataDeliveryServiceSourceArn?: Maybe<Scalars['String']['output']>;
  readonly securityDetails?: Maybe<GsocSecurityDetails>;
  readonly vita49StreamId?: Maybe<Scalars['Int']['output']>;
};

export type GsocNodeDataplaneDataDefenderDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocNodeDataplaneDataDefenderDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocNodeDataplaneDataDefenderDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocNodeDataplaneDataDefenderDetailsFilterInput>>;
  readonly dataDeliveryServiceDestinationArn?: InputMaybe<StringFilterInput>;
  readonly dataDeliveryServiceSourceArn?: InputMaybe<StringFilterInput>;
  readonly securityDetails?: InputMaybe<GsocSecurityDetailsFilterInput>;
  readonly vita49StreamId?: InputMaybe<IntegerFilterInput>;
};

export type GsocNodeDataplaneDetails = {
  readonly __typename?: 'GsocNodeDataplaneDetails';
  readonly dataDefender?: Maybe<GsocNodeDataplaneDataDefenderDetails>;
  readonly dataflowType?: Maybe<GsocDataplaneType>;
  readonly laminarFlow?: Maybe<GsocNodeDataplaneLaminarFlowDetails>;
};

export type GsocNodeDataplaneDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocNodeDataplaneDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocNodeDataplaneDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocNodeDataplaneDetailsFilterInput>>;
  readonly dataDefender?: InputMaybe<GsocNodeDataplaneDataDefenderDetailsFilterInput>;
  readonly dataflowType?: InputMaybe<GsocDataplaneTypeFilterInput>;
  readonly laminarFlow?: InputMaybe<GsocNodeDataplaneLaminarFlowDetailsFilterInput>;
};

export type GsocNodeDataplaneLaminarFlowDetails = {
  readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails';
  readonly agent?: Maybe<GsocNodeAgentDetails>;
  readonly egressAddress?: Maybe<GsocRangedConnectionDetails>;
  readonly ingressAddress?: Maybe<GsocRangedConnectionDetails>;
  readonly laminarflowConfig?: Maybe<Scalars['String']['output']>;
  readonly vita49StreamId?: Maybe<Scalars['Int']['output']>;
};

export type GsocNodeDataplaneLaminarFlowDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocNodeDataplaneLaminarFlowDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocNodeDataplaneLaminarFlowDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocNodeDataplaneLaminarFlowDetailsFilterInput>>;
  readonly agent?: InputMaybe<GsocNodeAgentDetailsFilterInput>;
  readonly egressAddress?: InputMaybe<GsocRangedConnectionDetailsFilterInput>;
  readonly ingressAddress?: InputMaybe<GsocRangedConnectionDetailsFilterInput>;
  readonly laminarflowConfig?: InputMaybe<StringFilterInput>;
  readonly vita49StreamId?: InputMaybe<IntegerFilterInput>;
};

export type GsocNodeDetails = {
  readonly __typename?: 'GsocNodeDetails';
  readonly dataplane?: Maybe<GsocNodeDataplaneDetails>;
  readonly orchestration?: Maybe<GsocNodeOrchestrationDetails>;
};

export type GsocNodeDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocNodeDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocNodeDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocNodeDetailsFilterInput>>;
  readonly dataplane?: InputMaybe<GsocNodeDataplaneDetailsFilterInput>;
  readonly orchestration?: InputMaybe<GsocNodeOrchestrationDetailsFilterInput>;
};

export type GsocNodeOrchestrationDetails = {
  readonly __typename?: 'GsocNodeOrchestrationDetails';
  readonly antennaDemodDecodeDetails?: Maybe<GsocAntennaDemodDecodeDetails>;
  readonly antennaDownlinkDetails?: Maybe<GsocAntennaDownlinkDetails>;
  readonly connectionProxyDetails?: Maybe<GsocConnectionProxyDetails>;
  readonly managedAntennaDemodDecodeDetails?: Maybe<GsocManagedAntennaDemodDecodeDetails>;
  readonly s3PlaybackDetails?: Maybe<GsocS3PlaybackDetails>;
  readonly s3RecordingDetails?: Maybe<GsocS3RecordingDetails>;
  readonly uplinkDetails?: Maybe<GsocUplinkDetails>;
  readonly uplinkEchoDetails?: Maybe<GsocUplinkEchoDetails>;
};

export type GsocNodeOrchestrationDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocNodeOrchestrationDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocNodeOrchestrationDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocNodeOrchestrationDetailsFilterInput>>;
  readonly antennaDemodDecodeDetails?: InputMaybe<GsocAntennaDemodDecodeDetailsFilterInput>;
  readonly antennaDownlinkDetails?: InputMaybe<GsocAntennaDownlinkDetailsFilterInput>;
  readonly connectionProxyDetails?: InputMaybe<GsocConnectionProxyDetailsFilterInput>;
  readonly managedAntennaDemodDecodeDetails?: InputMaybe<GsocManagedAntennaDemodDecodeDetailsFilterInput>;
  readonly s3PlaybackDetails?: InputMaybe<GsocS3PlaybackDetailsFilterInput>;
  readonly s3RecordingDetails?: InputMaybe<GsocS3RecordingDetailsFilterInput>;
  readonly uplinkDetails?: InputMaybe<GsocUplinkDetailsFilterInput>;
  readonly uplinkEchoDetails?: InputMaybe<GsocUplinkEchoDetailsFilterInput>;
};

export type GsocNodeV2 = {
  readonly __typename?: 'GsocNodeV2';
  readonly capability: GsocCapabilityV2;
  readonly config: GsocConfig;
  readonly nodeDetails: GsocNodeDetails;
  readonly region: Scalars['String']['output'];
  readonly telemetryInfo?: Maybe<GsocTelemetryInformation>;
};

export type GsocNodeV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocNodeV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocNodeV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocNodeV2FilterInput>>;
  readonly capability?: InputMaybe<GsocCapabilityV2FilterInput>;
  readonly config?: InputMaybe<GsocConfigFilterInput>;
  readonly nodeDetails?: InputMaybe<GsocNodeDetailsFilterInput>;
  readonly region?: InputMaybe<StringFilterInput>;
  readonly telemetryInfo?: InputMaybe<GsocTelemetryInformationFilterInput>;
};

export type GsocPageInfo = {
  readonly __typename?: 'GsocPageInfo';
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly lastCursor?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly total?: Maybe<GsocPageInfoTotal>;
};

export type GsocPageInfoTotal = {
  readonly __typename?: 'GsocPageInfoTotal';
  readonly relation?: Maybe<GsocPageInfoTotalRelation>;
  readonly value?: Maybe<Scalars['Int']['output']>;
};

export enum GsocPageInfoTotalRelation {
  Eq = 'eq',
  Gte = 'gte'
}

export type GsocRangedConnectionDetails = {
  readonly __typename?: 'GsocRangedConnectionDetails';
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly portRange: GsocIntegerRange;
};

export type GsocRangedConnectionDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocRangedConnectionDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocRangedConnectionDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocRangedConnectionDetailsFilterInput>>;
  readonly name?: InputMaybe<StringFilterInput>;
  readonly portRange?: InputMaybe<GsocIntegerRangeFilterInput>;
};

export type GsocRfCharacteristics = {
  readonly __typename?: 'GsocRfCharacteristics';
  /** Bandwidth is not present during uplink or uplink echo. */
  readonly bandwidth?: Maybe<Measurement>;
  readonly centerFrequency: Measurement;
  readonly polarization: Polarization;
};

export type GsocRfCharacteristicsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocRfCharacteristicsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocRfCharacteristicsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocRfCharacteristicsFilterInput>>;
  readonly bandwidth?: InputMaybe<MeasurementFilterInput>;
  readonly centerFrequency?: InputMaybe<MeasurementFilterInput>;
  readonly polarization?: InputMaybe<PolarizationFilterInput>;
};

export type GsocS3PlaybackDetails = {
  readonly __typename?: 'GsocS3PlaybackDetails';
  readonly bucketArn?: Maybe<Scalars['String']['output']>;
  readonly bucketRegion: Scalars['String']['output'];
  readonly keys?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly roleArn?: Maybe<Scalars['String']['output']>;
};

export type GsocS3PlaybackDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocS3PlaybackDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocS3PlaybackDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocS3PlaybackDetailsFilterInput>>;
  readonly bucketArn?: InputMaybe<StringFilterInput>;
  readonly bucketRegion?: InputMaybe<StringFilterInput>;
  readonly keys?: InputMaybe<StringFilterInput>;
  readonly roleArn?: InputMaybe<StringFilterInput>;
};

export type GsocS3RecordingDetails = {
  readonly __typename?: 'GsocS3RecordingDetails';
  readonly bucketArn?: Maybe<Scalars['String']['output']>;
  readonly bucketRegion: Scalars['String']['output'];
  readonly keyTemplate?: Maybe<Scalars['String']['output']>;
  readonly roleArn?: Maybe<Scalars['String']['output']>;
};

export type GsocS3RecordingDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocS3RecordingDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocS3RecordingDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocS3RecordingDetailsFilterInput>>;
  readonly bucketArn?: InputMaybe<StringFilterInput>;
  readonly bucketRegion?: InputMaybe<StringFilterInput>;
  readonly keyTemplate?: InputMaybe<StringFilterInput>;
  readonly roleArn?: InputMaybe<StringFilterInput>;
};

export type GsocSatellite = {
  readonly __typename?: 'GsocSatellite';
  /** Customer owning this satellite */
  readonly customer: GsocCustomer;
  /** AWS Satellite Resource ID */
  readonly id?: Maybe<Scalars['String']['output']>;
  /** Satellite Arn */
  readonly satelliteArn?: Maybe<Scalars['String']['output']>;
  /** Satellite Catalog Number */
  readonly satelliteCatalogNumber?: Maybe<Scalars['Int']['output']>;
  /** Satellite Name */
  readonly satelliteName?: Maybe<Scalars['String']['output']>;
  /** List of tags for tagging satellites for search purposes */
  readonly tags?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

export type GsocSatelliteAggregation = {
  readonly __typename?: 'GsocSatelliteAggregation';
  readonly satelliteCatalogNumber: Aggregation;
};

export type GsocSatelliteFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocSatelliteFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocSatelliteFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocSatelliteFilterInput>>;
  readonly customer?: InputMaybe<GsocCustomerFilterInput>;
  readonly satelliteArn?: InputMaybe<GsocStringFilterInput>;
  readonly satelliteCatalogNumber?: InputMaybe<IntegerFilterInput>;
  readonly satelliteName?: InputMaybe<GsocStringFilterInput>;
  readonly tags?: InputMaybe<GsocStringFilterInput>;
};

export type GsocSatelliteSortInput = {
  readonly satelliteArn?: InputMaybe<SortOrder>;
  readonly satelliteCatalogNumber?: InputMaybe<SortOrder>;
  readonly satelliteName?: InputMaybe<SortOrder>;
};

export type GsocSecurityDetails = {
  readonly __typename?: 'GsocSecurityDetails';
  readonly roleArn?: Maybe<Scalars['String']['output']>;
  readonly securityGroupIds: ReadonlyArray<Scalars['String']['output']>;
  readonly subnetIds: ReadonlyArray<Scalars['String']['output']>;
};

export type GsocSecurityDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocSecurityDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocSecurityDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocSecurityDetailsFilterInput>>;
  readonly roleArn?: InputMaybe<StringFilterInput>;
  readonly securityGroupIds?: InputMaybe<StringFilterInput>;
  readonly subnetIds?: InputMaybe<StringFilterInput>;
};

export type GsocStringFilterInput = {
  readonly _eq?: InputMaybe<Scalars['String']['input']>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _gt?: InputMaybe<Scalars['String']['input']>;
  readonly _gte?: InputMaybe<Scalars['String']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _lt?: InputMaybe<Scalars['String']['input']>;
  readonly _lte?: InputMaybe<Scalars['String']['input']>;
  readonly _neq?: InputMaybe<Scalars['String']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type GsocTelemetryInformation = {
  readonly __typename?: 'GsocTelemetryInformation';
  readonly telemetryScopeId: Scalars['String']['output'];
  readonly telemetrySourceArn: Scalars['String']['output'];
};

export type GsocTelemetryInformationFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocTelemetryInformationFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocTelemetryInformationFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocTelemetryInformationFilterInput>>;
  readonly telemetryScopeId?: InputMaybe<StringFilterInput>;
  readonly telemetrySourceArn?: InputMaybe<StringFilterInput>;
};

export type GsocTimeRangeFilterInput = {
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly endTime?: InputMaybe<AwsDateTimeFilterInput>;
  readonly startTime?: InputMaybe<AwsDateTimeFilterInput>;
};

export type GsocUplinkDetails = {
  readonly __typename?: 'GsocUplinkDetails';
  readonly rfCharacteristics: GsocRfCharacteristics;
  readonly targetEirp: Measurement;
  readonly transmitDisabled: Scalars['Boolean']['output'];
};

export type GsocUplinkDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocUplinkDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocUplinkDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocUplinkDetailsFilterInput>>;
  readonly rfCharacteristics?: InputMaybe<GsocRfCharacteristicsFilterInput>;
  readonly targetEirp?: InputMaybe<MeasurementFilterInput>;
  readonly transmitDisabled?: InputMaybe<BooleanFilterInput>;
};

export type GsocUplinkEchoDetails = {
  readonly __typename?: 'GsocUplinkEchoDetails';
  readonly enabled: Scalars['Boolean']['output'];
  readonly rfCharacteristics: GsocRfCharacteristics;
};

export type GsocUplinkEchoDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<GsocUplinkEchoDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<GsocUplinkEchoDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<GsocUplinkEchoDetailsFilterInput>>;
  readonly enabled?: InputMaybe<BooleanFilterInput>;
  readonly rfCharacteristics?: InputMaybe<GsocRfCharacteristicsFilterInput>;
};

export type InRegionAntennaDownlinkConfigData = {
  readonly __typename?: 'InRegionAntennaDownlinkConfigData';
  readonly bandwidth?: Maybe<Frequency>;
  readonly centerFrequency?: Maybe<Frequency>;
  readonly polarity?: Maybe<Polarization>;
};

export type InRegionAntennaDownlinkDemodDecodeConfigData = {
  readonly __typename?: 'InRegionAntennaDownlinkDemodDecodeConfigData';
  readonly bandwidthValue?: Maybe<Frequency>;
  readonly centerFrequency?: Maybe<Frequency>;
  readonly decodeConfigData?: Maybe<InRegionDecodeConfigData>;
  readonly demodulationConfigData?: Maybe<InRegionDemodulationConfigData>;
  readonly polarity?: Maybe<Polarization>;
};

export type InRegionAntennaDownlinkDemodDecodeExecutionContextData = {
  readonly __typename?: 'InRegionAntennaDownlinkDemodDecodeExecutionContextData';
  readonly antennaDownlinkDemodDecodeConfigData?: Maybe<InRegionAntennaDownlinkDemodDecodeConfigData>;
  readonly antennaDownlinkDemodDecodeConfigId?: Maybe<Scalars['String']['output']>;
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextDataflows?: Maybe<ReadonlyArray<InRegionExecutionContextDataflowData>>;
  readonly outputToDataDeliveryServiceSourceArnMap?: Maybe<ReadonlyArray<StringToStringMapEntry>>;
  readonly outputToDestinationMtuMap?: Maybe<ReadonlyArray<StringToIntegerMapEntry>>;
};

export type InRegionAntennaDownlinkExecutionContextData = {
  readonly __typename?: 'InRegionAntennaDownlinkExecutionContextData';
  readonly antennaDownlinkConfigData?: Maybe<InRegionAntennaDownlinkConfigData>;
  readonly antennaDownlinkConfigId?: Maybe<Scalars['String']['output']>;
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataDeliveryServiceSourceArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextDataflowData?: Maybe<InRegionExecutionContextDataflowData>;
};

export type InRegionAntennaUplinkConfigData = {
  readonly __typename?: 'InRegionAntennaUplinkConfigData';
  readonly centerFrequency?: Maybe<Frequency>;
  readonly polarity?: Maybe<Polarization>;
  readonly targetEirpUnit?: Maybe<Scalars['String']['output']>;
  readonly targetEirpValue?: Maybe<Scalars['Float']['output']>;
  readonly transmitDisabled?: Maybe<Scalars['Boolean']['output']>;
};

export type InRegionAntennaUplinkExecutionContextData = {
  readonly __typename?: 'InRegionAntennaUplinkExecutionContextData';
  readonly antennaUplinkConfigData?: Maybe<InRegionAntennaUplinkConfigData>;
  readonly antennaUplinkConfigId?: Maybe<Scalars['String']['output']>;
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataDeliveryServiceSourceArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextDataflowData?: Maybe<InRegionExecutionContextDataflowData>;
};

export type InRegionConnectionProxyExecutionContextData = {
  readonly __typename?: 'InRegionConnectionProxyExecutionContextData';
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowTranslation?: Maybe<DataflowTranslation>;
  readonly executionContextDataflowData?: Maybe<InRegionExecutionContextDataflowData>;
};

export enum InRegionContactDataType {
  ContactRequest = 'CONTACT_REQUEST',
  ExecutionContext = 'EXECUTION_CONTEXT'
}

export type InRegionContactDdbTable = {
  readonly __typename?: 'InRegionContactDdbTable';
  /** The contact identifier. */
  readonly contactId: Scalars['String']['output'];
  /** Present when CONTACT_REQUEST data type. */
  readonly contactRequestData?: Maybe<InRegionContactRequestData>;
  /** The data identifier for this record. */
  readonly dataUuid: Scalars['String']['output'];
  /** Present when EXECUTION_CONTEXT data type */
  readonly executionContext?: Maybe<Scalars['String']['output']>;
  /** Present when EXECUTION_CONTEXT data type, after parsing. */
  readonly executionContextStruct?: Maybe<InRegionExecutionContextData>;
  /** Enumeration to determine the record type. */
  readonly inRegionContactDataType: InRegionContactDataType;
  /** Version number of the record. */
  readonly versionNumber: Scalars['Int']['output'];
};

export type InRegionContactRequestData = {
  readonly __typename?: 'InRegionContactRequestData';
  readonly antennaSystemId?: Maybe<Scalars['String']['output']>;
  readonly awsAccountId?: Maybe<Scalars['String']['output']>;
  readonly capabilitiesToTest?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly contactArn?: Maybe<Scalars['String']['output']>;
  readonly contactId?: Maybe<Scalars['String']['output']>;
  readonly contactType?: Maybe<ContactType>;
  readonly createdInRegion?: Maybe<Scalars['String']['output']>;
  readonly dereferenceMissionProfileData?: Maybe<DereferencedMissionProfileData>;
  readonly groundstationId?: Maybe<Scalars['String']['output']>;
  readonly requestedNodes?: Maybe<ReadonlyArray<RequestedNodesMapEntry>>;
  readonly satelliteArn?: Maybe<Scalars['String']['output']>;
  readonly targetRegion?: Maybe<Scalars['String']['output']>;
};

export type InRegionDataflowEndpointExecutionContextData = {
  readonly __typename?: 'InRegionDataflowEndpointExecutionContextData';
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataDeliveryServiceDestinationArn?: Maybe<Scalars['String']['output']>;
  readonly dataDeliveryServiceSourceArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowEndpointGroupArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextDataflowData?: Maybe<InRegionExecutionContextDataflowData>;
};

export type InRegionDecodeConfigData = {
  readonly __typename?: 'InRegionDecodeConfigData';
  readonly unvalidatedJSON?: Maybe<Scalars['String']['output']>;
};

export type InRegionDemodulationConfigData = {
  readonly __typename?: 'InRegionDemodulationConfigData';
  readonly unvalidatedJSON?: Maybe<Scalars['String']['output']>;
};

export type InRegionExecutionContextData = {
  readonly __typename?: 'InRegionExecutionContextData';
  readonly antennaDownlinkDemodDecodeExecutionContextData?: Maybe<InRegionAntennaDownlinkDemodDecodeExecutionContextData>;
  readonly antennaDownlinkExecutionContextData?: Maybe<InRegionAntennaDownlinkExecutionContextData>;
  readonly antennaUplinkExecutionContextData?: Maybe<InRegionAntennaUplinkExecutionContextData>;
  readonly capabilityArn?: Maybe<Scalars['String']['output']>;
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly connectionProxyExecutionContextData?: Maybe<InRegionConnectionProxyExecutionContextData>;
  readonly dataflowEndpointExecutionContextData?: Maybe<InRegionDataflowEndpointExecutionContextData>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextId?: Maybe<Scalars['String']['output']>;
  readonly executionContextType?: Maybe<ConfigCapabilityType>;
  readonly laminarFlowConfigString?: Maybe<Scalars['String']['output']>;
  readonly managedAntennaDownlinkDemodDecodeExecutionContextData?: Maybe<InRegionManagedAntennaDownlinkDemodDecodeExecutionContextData>;
  readonly s3PlaybackExecutionContextData?: Maybe<InRegionS3PlaybackExecutionContextData>;
  readonly s3RecordingExecutionContextData?: Maybe<InRegionS3RecordingExecutionContextData>;
  readonly telemetryScopeId?: Maybe<Scalars['String']['output']>;
  readonly telemetrySourceArn?: Maybe<Scalars['String']['output']>;
  readonly trackingExecutionContextData?: Maybe<InRegionTrackingExecutionContextData>;
  readonly type?: Maybe<ConfigCapabilityType>;
  readonly uplinkEchoExecutionContextData?: Maybe<InRegionUplinkEchoExecutionContextData>;
};

export type InRegionExecutionContextDataflowData = {
  readonly __typename?: 'InRegionExecutionContextDataflowData';
  readonly dataflowId?: Maybe<Scalars['String']['output']>;
  readonly dataflowRate?: Maybe<Measurement>;
  readonly destinationIngressAddress?: Maybe<InRegionRangedSocketAddressInfo>;
  readonly egressAddress?: Maybe<InRegionRangedSocketAddressInfo>;
  readonly ingressAddress?: Maybe<InRegionRangedSocketAddressInfo>;
  readonly isMultiChannel?: Maybe<Scalars['Boolean']['output']>;
  readonly sourceAccount?: Maybe<Scalars['String']['output']>;
  readonly sourceArn?: Maybe<Scalars['String']['output']>;
  readonly sourceEgressAddress?: Maybe<InRegionRangedSocketAddressInfo>;
  readonly vita49StreamId?: Maybe<Scalars['Int']['output']>;
};

export type InRegionManagedAntennaDownlinkDemodDecodeConfigData = {
  readonly __typename?: 'InRegionManagedAntennaDownlinkDemodDecodeConfigData';
  readonly managedRadioConfigId?: Maybe<Scalars['String']['output']>;
  readonly spectrumConfig?: Maybe<InRegionManagedAntennaDownlinkDemodDecodeSpectrumConfig>;
  readonly supportedOutputTypes?: Maybe<ReadonlyArray<InRegionManagedAntennaDownlinkDemodDecodeSupportedOutputType>>;
};

export type InRegionManagedAntennaDownlinkDemodDecodeExecutionContextData = {
  readonly __typename?: 'InRegionManagedAntennaDownlinkDemodDecodeExecutionContextData';
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextDataflows?: Maybe<ReadonlyArray<InRegionExecutionContextDataflowData>>;
  readonly managedAntennaDownlinkDemodDecodeConfigData?: Maybe<InRegionManagedAntennaDownlinkDemodDecodeConfigData>;
  readonly managedAntennaDownlinkDemodDecodeConfigId?: Maybe<Scalars['String']['output']>;
};

export type InRegionManagedAntennaDownlinkDemodDecodeSpectrumConfig = {
  readonly __typename?: 'InRegionManagedAntennaDownlinkDemodDecodeSpectrumConfig';
  readonly bandwidth?: Maybe<Frequency>;
  readonly centerFrequency?: Maybe<Frequency>;
  readonly polarization?: Maybe<Polarization>;
};

export type InRegionManagedAntennaDownlinkDemodDecodeSupportedOutputType = {
  readonly __typename?: 'InRegionManagedAntennaDownlinkDemodDecodeSupportedOutputType';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type InRegionRangedSocketAddressInfo = {
  readonly __typename?: 'InRegionRangedSocketAddressInfo';
  readonly maximumPort?: Maybe<Scalars['Int']['output']>;
  readonly minimumPort?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type InRegionS3PlaybackConfigData = {
  readonly __typename?: 'InRegionS3PlaybackConfigData';
  readonly bucketArn?: Maybe<Scalars['String']['output']>;
  readonly bucketRegion?: Maybe<Scalars['String']['output']>;
  readonly playbackFrequency?: Maybe<Frequency>;
  readonly roleArn?: Maybe<Scalars['String']['output']>;
};

export type InRegionS3PlaybackConfigDto = {
  readonly __typename?: 'InRegionS3PlaybackConfigDto';
  readonly awsAccountId?: Maybe<Scalars['String']['output']>;
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly configId?: Maybe<Scalars['String']['output']>;
  readonly s3PlaybackConfigData?: Maybe<InRegionS3PlaybackConfigData>;
  readonly type?: Maybe<ConfigCapabilityType>;
};

export type InRegionS3PlaybackExecutionContextData = {
  readonly __typename?: 'InRegionS3PlaybackExecutionContextData';
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextDataflowData?: Maybe<InRegionExecutionContextDataflowData>;
  readonly s3PlaybackConfigDto?: Maybe<InRegionS3PlaybackConfigDto>;
};

export type InRegionS3RecordingConfigData = {
  readonly __typename?: 'InRegionS3RecordingConfigData';
  readonly bucketArn?: Maybe<Scalars['String']['output']>;
  readonly bucketRegion?: Maybe<Scalars['String']['output']>;
  readonly prefix?: Maybe<Scalars['String']['output']>;
  readonly roleArn?: Maybe<Scalars['String']['output']>;
};

export type InRegionS3RecordingConfigDto = {
  readonly __typename?: 'InRegionS3RecordingConfigDto';
  readonly awsAccountId?: Maybe<Scalars['String']['output']>;
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly configId?: Maybe<Scalars['String']['output']>;
  readonly createdInRegion?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly region?: Maybe<Scalars['String']['output']>;
  readonly s3RecordingConfigData?: Maybe<InRegionS3RecordingConfigData>;
  readonly type?: Maybe<ConfigCapabilityType>;
};

export type InRegionS3RecordingExecutionContextData = {
  readonly __typename?: 'InRegionS3RecordingExecutionContextData';
  readonly dataDeliveryServiceDestinationArn?: Maybe<Scalars['String']['output']>;
  readonly dataDeliveryServiceSourceArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextDataflowData?: Maybe<InRegionExecutionContextDataflowData>;
  readonly s3RecordingConfigDto?: Maybe<InRegionS3RecordingConfigDto>;
};

export type InRegionTrackingExecutionContextData = {
  readonly __typename?: 'InRegionTrackingExecutionContextData';
  readonly autotrackCriticality?: Maybe<CpCriticality>;
};

export type InRegionUplinkEchoConfigData = {
  readonly __typename?: 'InRegionUplinkEchoConfigData';
  readonly antennaUplinkArn?: Maybe<Scalars['String']['output']>;
  readonly centerFrequency?: Maybe<Frequency>;
  readonly enabled?: Maybe<Scalars['Boolean']['output']>;
  readonly polarity?: Maybe<Polarization>;
};

export type InRegionUplinkEchoExecutionContextData = {
  readonly __typename?: 'InRegionUplinkEchoExecutionContextData';
  readonly configArn?: Maybe<Scalars['String']['output']>;
  readonly dataDeliveryServiceSourceArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowType?: Maybe<CpDataflowType>;
  readonly executionContextDataflowData?: Maybe<InRegionExecutionContextDataflowData>;
  readonly uplinkEchoConfigData?: Maybe<InRegionUplinkEchoConfigData>;
  readonly uplinkEchoConfigId?: Maybe<Scalars['String']['output']>;
};

export type IntegerFilterInput = {
  readonly _eq?: InputMaybe<Scalars['Int']['input']>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _gt?: InputMaybe<Scalars['Int']['input']>;
  readonly _gte?: InputMaybe<Scalars['Int']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly _lt?: InputMaybe<Scalars['Int']['input']>;
  readonly _lte?: InputMaybe<Scalars['Int']['input']>;
  readonly _neq?: InputMaybe<Scalars['Int']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
};

export type ListGsocContactV2Input = {
  readonly cursor?: InputMaybe<ReadonlyArray<CursorPartInput>>;
  readonly limit?: InputMaybe<Scalars['Int']['input']>;
  readonly sort?: InputMaybe<ReadonlyArray<GsocContactV2SortInput>>;
  readonly where?: InputMaybe<GsocContactV2FilterInput>;
};

export type ListGsocContactV2Output = {
  readonly __typename?: 'ListGsocContactV2Output';
  readonly aggregations: GsocContactV2Aggregation;
  readonly pageInfo: PageInfo;
  readonly results: ReadonlyArray<GsocContactV2>;
};

export type ListGsocContactsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<ListGsocContactsFilterInput>>;
  readonly _not?: InputMaybe<ListGsocContactsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<ListGsocContactsFilterInput>>;
  readonly contactId?: InputMaybe<GsocStringFilterInput>;
  readonly contactStatus?: InputMaybe<GsocContactStatusFilterInput>;
  readonly customer?: InputMaybe<GsocCustomerFilterInput>;
  readonly destinationRegions?: InputMaybe<GsocStringFilterInput>;
  readonly groundStations?: InputMaybe<GsocGroundStationFilterInput>;
  readonly missionProfile?: InputMaybe<GsocMissionProfileFilterInput>;
  readonly satellite?: InputMaybe<GsocSatelliteFilterInput>;
  readonly schedulingRegion?: InputMaybe<GsocStringFilterInput>;
  readonly tags?: InputMaybe<GsocStringFilterInput>;
  readonly telemetryRouteList?: InputMaybe<GsocStringFilterInput>;
  readonly timeRange?: InputMaybe<GsocTimeRangeFilterInput>;
};

export type ListGsocContactsSortInput = {
  readonly contactId?: InputMaybe<SortOrder>;
  readonly contactStatus?: InputMaybe<SortOrder>;
  readonly customer?: InputMaybe<GsocCustomerSortInput>;
  readonly missionProfile?: InputMaybe<GsocMissionProfileSortInput>;
  readonly satellite?: InputMaybe<GsocSatelliteSortInput>;
  readonly schedulingRegion?: InputMaybe<SortOrder>;
  readonly timeRange?: InputMaybe<TimeRangeSortInput>;
};

export type Measurement = {
  readonly __typename?: 'Measurement';
  readonly unit: Scalars['String']['output'];
  readonly value: Scalars['Float']['output'];
};

export type MeasurementFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<MeasurementFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<MeasurementFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<MeasurementFilterInput>>;
  readonly unit?: InputMaybe<StringFilterInput>;
  readonly value?: InputMaybe<FloatFilterInput>;
};

export enum MeteringStatus {
  MeteringFailed = 'METERING_FAILED',
  MeteringQueued = 'METERING_QUEUED',
  MeteringRequiredCancelled = 'METERING_REQUIRED_CANCELLED',
  MeteringRequiredCompleted = 'METERING_REQUIRED_COMPLETED',
  MeteringRequiredNegative = 'METERING_REQUIRED_NEGATIVE'
}

export enum MeteringUsage {
  Midband = 'MIDBAND',
  Narrowband = 'NARROWBAND',
  Wideband = 'WIDEBAND'
}

export type NamedImage = {
  readonly __typename?: 'NamedImage';
  readonly imageBase64: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
};

export type NamedImageV2 = {
  readonly __typename?: 'NamedImageV2';
  /** Interactive HTML version of this plot, if available */
  readonly htmlImage?: Maybe<S3Object>;
  readonly image: S3Object;
  readonly name: Scalars['String']['output'];
};

export type NamedImageV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<NamedImageV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<NamedImageV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<NamedImageV2FilterInput>>;
  readonly htmlImage?: InputMaybe<S3ObjectFilterInput>;
  readonly image?: InputMaybe<S3ObjectFilterInput>;
  readonly name?: InputMaybe<StringFilterInput>;
};

export type PageInfo = {
  readonly __typename?: 'PageInfo';
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly lastCursor?: Maybe<ReadonlyArray<CursorPart>>;
  readonly total: Total;
};

export enum Polarization {
  Both = 'BOTH',
  LeftHand = 'LEFT_HAND',
  None = 'NONE',
  RightHand = 'RIGHT_HAND'
}

export type PolarizationFilterInput = {
  readonly _eq?: InputMaybe<Polarization>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Polarization>>;
  readonly _neq?: InputMaybe<Polarization>;
  readonly _nin?: InputMaybe<ReadonlyArray<Polarization>>;
};

export type Query = {
  readonly __typename?: 'Query';
  readonly getGsocContactV2?: Maybe<GsocContactV2>;
  readonly getUserPermissionClaims: ReadonlyArray<Scalars['String']['output']>;
  readonly gsocGetContactDetails?: Maybe<GsocContactDetails>;
  readonly gsocListContactsPaginated?: Maybe<GsocListContactsPaginatedOutput>;
  readonly gsocListIamRoles?: Maybe<GsocListIamRolesOutput>;
  readonly listGsocContactV2?: Maybe<ListGsocContactV2Output>;
};


export type QueryGetGsocContactV2Args = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: GetGsocContactV2Input;
};


export type QueryGsocGetContactDetailsArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: GsocGetContactDetailsInput;
};


export type QueryGsocListContactsPaginatedArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: GsocListContactsPaginatedInput;
};


export type QueryGsocListIamRolesArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListGsocContactV2Args = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: ListGsocContactV2Input;
};

export enum Relation {
  Eq = 'eq',
  Gte = 'gte'
}

export type RequestedDagNodeInfo = {
  readonly __typename?: 'RequestedDagNodeInfo';
  readonly dataflowUuid?: Maybe<Scalars['String']['output']>;
  readonly region?: Maybe<Scalars['String']['output']>;
  readonly versionedConfigId?: Maybe<Scalars['String']['output']>;
  readonly vita49StreamId?: Maybe<Scalars['String']['output']>;
};

export type RequestedNodesMapEntry = {
  readonly __typename?: 'RequestedNodesMapEntry';
  readonly key?: Maybe<Scalars['String']['output']>;
  readonly value?: Maybe<RequestedDagNodeInfo>;
};

export enum ReservationStatus {
  AwsFailed = 'AWS_FAILED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Deleted = 'DELETED',
  Failed = 'FAILED',
  Pass = 'PASS',
  Postpass = 'POSTPASS',
  Prepass = 'PREPASS',
  Scheduled = 'SCHEDULED',
  Scheduling = 'SCHEDULING'
}

export type RfCharacteristics = {
  readonly __typename?: 'RfCharacteristics';
  readonly frequencyBand?: Maybe<FrequencyBand>;
  readonly polarization?: Maybe<Polarization>;
};

export type S3Object = {
  readonly __typename?: 'S3Object';
  readonly presignedUrl: Scalars['String']['output'];
  readonly s3Uri: Scalars['String']['output'];
};

export type S3ObjectFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<S3ObjectFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<S3ObjectFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<S3ObjectFilterInput>>;
  readonly s3Uri?: InputMaybe<StringFilterInput>;
};

export type S3ObjectSortInput = {
  readonly s3Uri?: InputMaybe<SortOrder>;
};

export type SignatureMapEntry = {
  readonly __typename?: 'SignatureMapEntry';
  readonly key?: Maybe<Scalars['String']['output']>;
  readonly value?: Maybe<Scalars['Boolean']['output']>;
};

export type SignatureMapFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<SignatureMapFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<SignatureMapFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<SignatureMapFilterInput>>;
  readonly key?: InputMaybe<StringFilterInput>;
  readonly value?: InputMaybe<BooleanFilterInput>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StringFilterInput = {
  readonly _eq?: InputMaybe<Scalars['String']['input']>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _gt?: InputMaybe<Scalars['String']['input']>;
  readonly _gte?: InputMaybe<Scalars['String']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _lt?: InputMaybe<Scalars['String']['input']>;
  readonly _lte?: InputMaybe<Scalars['String']['input']>;
  readonly _neq?: InputMaybe<Scalars['String']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringToIntegerMapEntry = {
  readonly __typename?: 'StringToIntegerMapEntry';
  readonly key?: Maybe<Scalars['String']['output']>;
  readonly value?: Maybe<Scalars['Int']['output']>;
};

export type StringToStringMapEntry = {
  readonly __typename?: 'StringToStringMapEntry';
  readonly key?: Maybe<Scalars['String']['output']>;
  readonly value?: Maybe<Scalars['String']['output']>;
};

export type TimeRange = {
  readonly __typename?: 'TimeRange';
  readonly endTime: Scalars['AWSDateTime']['output'];
  readonly startTime: Scalars['AWSDateTime']['output'];
};

export type TimeRangeFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<TimeRangeFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<TimeRangeFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<TimeRangeFilterInput>>;
  readonly endTime?: InputMaybe<TimestampFilterInput>;
  readonly startTime?: InputMaybe<TimestampFilterInput>;
};

export type TimeRangeSortInput = {
  readonly endTime?: InputMaybe<SortOrder>;
  readonly startTime?: InputMaybe<SortOrder>;
};

export type TimestampFilterInput = {
  readonly _eq?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _gt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _gte?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['AWSDateTime']['input']>>;
  readonly _lt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _lte?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _neq?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['AWSDateTime']['input']>>;
};

export type Total = {
  readonly __typename?: 'Total';
  readonly relation?: Maybe<Relation>;
  readonly value?: Maybe<Scalars['Int']['output']>;
};

export type TranslationConfiguration = {
  readonly __typename?: 'TranslationConfiguration';
  readonly laminarFlowConfig?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<DeliveryMechanism>;
  readonly vpcAttachmentDetails?: Maybe<VpcAttachmentDetails>;
};

export type TranslationConfigurationFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<TranslationConfigurationFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<TranslationConfigurationFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<TranslationConfigurationFilterInput>>;
  readonly laminarFlowConfig?: InputMaybe<StringFilterInput>;
  readonly type?: InputMaybe<DeliveryMechanismFilterInput>;
  readonly vpcAttachmentDetails?: InputMaybe<VpcAttachmentDetailsFilterInput>;
};

export type TranslationDetail = {
  readonly __typename?: 'TranslationDetail';
  readonly deliveryMechanism?: Maybe<DeliveryMechanism>;
  readonly translationConfiguration?: Maybe<TranslationConfiguration>;
};

export type TranslationDetailFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<TranslationDetailFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<TranslationDetailFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<TranslationDetailFilterInput>>;
  readonly deliveryMechanism?: InputMaybe<DeliveryMechanismFilterInput>;
  readonly translationConfiguration?: InputMaybe<TranslationConfigurationFilterInput>;
};

export type Vita49StreamCharacteristics = {
  readonly __typename?: 'Vita49StreamCharacteristics';
  readonly vitaInterfaceType?: Maybe<Vita492SchemaType>;
  readonly vitaStreamId?: Maybe<Scalars['Int']['output']>;
};

export enum Vita492SchemaType {
  AwsGsType_1 = 'AWS_GS_TYPE_1',
  AwsGsType_2 = 'AWS_GS_TYPE_2'
}

export type VpcAttachmentDetails = {
  readonly __typename?: 'VpcAttachmentDetails';
  readonly customerRoleArn?: Maybe<Scalars['String']['output']>;
  readonly dataflowEndpointGroupArn?: Maybe<Scalars['String']['output']>;
  readonly securityGroupIdList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly subnetIdList?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
};

export type VpcAttachmentDetailsFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<VpcAttachmentDetailsFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<VpcAttachmentDetailsFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<VpcAttachmentDetailsFilterInput>>;
  readonly customerRoleArn?: InputMaybe<StringFilterInput>;
  readonly dataflowEndpointGroupArn?: InputMaybe<StringFilterInput>;
  readonly securityGroupIdList?: InputMaybe<StringFilterInput>;
  readonly subnetIdList?: InputMaybe<StringFilterInput>;
};

/**
 * A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.
 *
 * In some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.
 */
export type __Directive = {
  readonly __typename?: '__Directive';
  readonly name: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly isRepeatable: Scalars['Boolean']['output'];
  readonly locations: ReadonlyArray<__DirectiveLocation>;
  readonly args: ReadonlyArray<__InputValue>;
};


/**
 * A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.
 *
 * In some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.
 */
export type __DirectiveArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies. */
export enum __DirectiveLocation {
  /** Location adjacent to a query operation. */
  Query = 'QUERY',
  /** Location adjacent to a mutation operation. */
  Mutation = 'MUTATION',
  /** Location adjacent to a subscription operation. */
  Subscription = 'SUBSCRIPTION',
  /** Location adjacent to a field. */
  Field = 'FIELD',
  /** Location adjacent to a fragment definition. */
  FragmentDefinition = 'FRAGMENT_DEFINITION',
  /** Location adjacent to a fragment spread. */
  FragmentSpread = 'FRAGMENT_SPREAD',
  /** Location adjacent to an inline fragment. */
  InlineFragment = 'INLINE_FRAGMENT',
  /** Location adjacent to a variable definition. */
  VariableDefinition = 'VARIABLE_DEFINITION',
  /** Location adjacent to a schema definition. */
  Schema = 'SCHEMA',
  /** Location adjacent to a scalar definition. */
  Scalar = 'SCALAR',
  /** Location adjacent to an object type definition. */
  Object = 'OBJECT',
  /** Location adjacent to a field definition. */
  FieldDefinition = 'FIELD_DEFINITION',
  /** Location adjacent to an argument definition. */
  ArgumentDefinition = 'ARGUMENT_DEFINITION',
  /** Location adjacent to an interface definition. */
  Interface = 'INTERFACE',
  /** Location adjacent to a union definition. */
  Union = 'UNION',
  /** Location adjacent to an enum definition. */
  Enum = 'ENUM',
  /** Location adjacent to an enum value definition. */
  EnumValue = 'ENUM_VALUE',
  /** Location adjacent to an input object type definition. */
  InputObject = 'INPUT_OBJECT',
  /** Location adjacent to an input object field definition. */
  InputFieldDefinition = 'INPUT_FIELD_DEFINITION'
}

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  readonly __typename?: '__EnumValue';
  readonly name: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly isDeprecated: Scalars['Boolean']['output'];
  readonly deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  readonly __typename?: '__Field';
  readonly name: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly args: ReadonlyArray<__InputValue>;
  readonly type: __Type;
  readonly isDeprecated: Scalars['Boolean']['output'];
  readonly deprecationReason?: Maybe<Scalars['String']['output']>;
};


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  readonly __typename?: '__InputValue';
  readonly name: Scalars['String']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  readonly defaultValue?: Maybe<Scalars['String']['output']>;
  readonly isDeprecated: Scalars['Boolean']['output'];
  readonly deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations. */
export type __Schema = {
  readonly __typename?: '__Schema';
  readonly description?: Maybe<Scalars['String']['output']>;
  /** A list of all types supported by this server. */
  readonly types: ReadonlyArray<__Type>;
  /** The type that query operations will be rooted at. */
  readonly queryType: __Type;
  /** If this server supports mutation, the type that mutation operations will be rooted at. */
  readonly mutationType?: Maybe<__Type>;
  /** If this server support subscription, the type that subscription operations will be rooted at. */
  readonly subscriptionType?: Maybe<__Type>;
  /** A list of all directives supported by this server. */
  readonly directives: ReadonlyArray<__Directive>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  readonly __typename?: '__Type';
  readonly kind: __TypeKind;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly specifiedByURL?: Maybe<Scalars['String']['output']>;
  readonly fields?: Maybe<ReadonlyArray<__Field>>;
  readonly interfaces?: Maybe<ReadonlyArray<__Type>>;
  readonly possibleTypes?: Maybe<ReadonlyArray<__Type>>;
  readonly enumValues?: Maybe<ReadonlyArray<__EnumValue>>;
  readonly inputFields?: Maybe<ReadonlyArray<__InputValue>>;
  readonly ofType?: Maybe<__Type>;
  readonly isOneOf?: Maybe<Scalars['Boolean']['output']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByURL`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
}

export type ListContactsQueryVariables = Exact<{
  input: ListGsocContactV2Input;
}>;


export type ListContactsQuery = { readonly __typename?: 'Query', readonly listContacts?: { readonly __typename?: 'ListGsocContactV2Output', readonly results: ReadonlyArray<{ readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly contactStatus: ContactStatus, readonly failedToScheduleReasons?: ReadonlyArray<string> | null, readonly telemetryRouteList?: ReadonlyArray<string> | null, readonly schedulingRegion: string, readonly destinationRegions: ReadonlyArray<string>, readonly customer: { readonly __typename?: 'GsocCustomer', readonly awsAccountId?: string | null, readonly awsGsaasAwsAccountNamePart: string, readonly external: boolean }, readonly groundStations?: ReadonlyArray<{ readonly __typename?: 'GsocGroundStation', readonly groundStationName: string, readonly antennaName?: string | null }> | null, readonly missionProfile: { readonly __typename?: 'GsocMissionProfile', readonly missionProfileArn?: string | null, readonly missionProfileId: string }, readonly satellite?: { readonly __typename?: 'GsocSatellite', readonly satelliteCatalogNumber?: number | null, readonly satelliteName?: string | null, readonly satelliteArn?: string | null } | null, readonly timeRange: { readonly __typename?: 'TimeRange', readonly startTime: Date, readonly endTime: Date } }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null };

export type GetStatisticInformationForContactQueryVariables = Exact<{
  awsAccountId: Scalars['String']['input'];
  satelliteId?: InputMaybe<Scalars['String']['input']>;
  missionProfileArn: Scalars['String']['input'];
  groundStationName: Scalars['String']['input'];
  startTime: Scalars['AWSDateTime']['input'];
  endTime: Scalars['AWSDateTime']['input'];
}>;


export type GetStatisticInformationForContactQuery = { readonly __typename?: 'Query', readonly missionProfileCompleted?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly missionProfileFailed?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly missionProfileAwsFailed?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly missionProfileCancelled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly missionProfileAwsCancelled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly missionProfileScheduled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly missionProfileFailedToSchedule?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly satelliteCompleted?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly satelliteFailed?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly satelliteAwsFailed?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly satelliteCancelled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly satelliteAwsCancelled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly satelliteScheduled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly satelliteFailedToSchedule?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly accountCompleted?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly accountFailed?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly accountAwsFailed?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly accountCancelled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly accountAwsCancelled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly accountScheduled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly accountFailedToSchedule?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly groundStationCompleted?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly groundStationFailed?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly groundStationAwsFailed?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly groundStationCancelled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly groundStationAwsCancelled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly groundStationScheduled?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null, readonly groundStationFailedToSchedule?: { readonly __typename?: 'ListGsocContactV2Output', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } } } | null };

export type GetContactQueryVariables = Exact<{
  input: GetGsocContactV2Input;
}>;


export type GetContactQuery = { readonly __typename?: 'Query', readonly getContact?: { readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly contactStatus: ContactStatus, readonly failedToScheduleReasons?: ReadonlyArray<string> | null, readonly telemetryRouteList?: ReadonlyArray<string> | null, readonly schedulingRegion: string, readonly destinationRegions: ReadonlyArray<string>, readonly customer: { readonly __typename?: 'GsocCustomer', readonly awsAccountId?: string | null, readonly awsGsaasAwsAccountNamePart: string, readonly external: boolean }, readonly dataflows?: ReadonlyArray<{ readonly __typename?: 'GsocDataflowV2', readonly dataflowId: string, readonly destination: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string }, readonly htmlImage?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null }> }, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null } }, readonly source: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string }, readonly htmlImage?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null }> }, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null } } }> | null, readonly groundStations?: ReadonlyArray<{ readonly __typename?: 'GsocGroundStation', readonly groundStationName: string, readonly antennaName?: string | null }> | null, readonly missionProfile: { readonly __typename?: 'GsocMissionProfile', readonly missionProfileArn?: string | null, readonly missionProfileId: string }, readonly satellite?: { readonly __typename?: 'GsocSatellite', readonly satelliteCatalogNumber?: number | null, readonly satelliteName?: string | null, readonly satelliteArn?: string | null } | null, readonly timeRange: { readonly __typename?: 'TimeRange', readonly startTime: Date, readonly endTime: Date }, readonly acuPlots?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null, readonly contactPlots?: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string }, readonly htmlImage?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null }> | null } | null };

export type GetEphemerisInfoListQueryVariables = Exact<{
  contactId: Scalars['String']['input'];
}>;


export type GetEphemerisInfoListQuery = { readonly __typename?: 'Query', readonly getGsocContactV2?: { readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly ephemerisInfoList?: ReadonlyArray<{ readonly __typename?: 'EphemerisInfo', readonly ephemerisSourceType?: EphemerisSourceType | null, readonly ephemerisId: string, readonly updateTime: Date, readonly usageType: ContactEphemerisUsageType }> | null } | null };

export type GetSignatureMapQueryVariables = Exact<{
  contactId: Scalars['String']['input'];
}>;


export type GetSignatureMapQuery = { readonly __typename?: 'Query', readonly getGsocContactV2?: { readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly signatureMap?: ReadonlyArray<{ readonly __typename?: 'SignatureMapEntry', readonly key?: string | null, readonly value?: boolean | null }> | null } | null };

export type ContactImagesFragment = { readonly __typename?: 'GsocContactV2', readonly dataflows?: ReadonlyArray<{ readonly __typename?: 'GsocDataflowV2', readonly dataflowId: string, readonly destination: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string }, readonly htmlImage?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null }> }, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null } }, readonly source: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string }, readonly htmlImage?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null }> }, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null } } }> | null, readonly acuPlots?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null, readonly contactPlots?: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string }, readonly htmlImage?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null }> | null };

export type DataflowImagesFragment = { readonly __typename?: 'GsocDataflowV2', readonly destination: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string }, readonly htmlImage?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null }> }, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly value: number, readonly unit: string } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null } }, readonly source: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string }, readonly htmlImage?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null }> }, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly value: number, readonly unit: string } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null } } };

export type AntennaCapabilityContactSummaryFragment = { readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly contactStatus: ContactStatus, readonly timeRange: { readonly __typename?: 'TimeRange', readonly startTime: Date, readonly endTime: Date }, readonly groundStations?: ReadonlyArray<{ readonly __typename?: 'GsocGroundStation', readonly groundStationName: string, readonly antennaName?: string | null }> | null, readonly customer: { readonly __typename?: 'GsocCustomer', readonly awsAccountId?: string | null, readonly external: boolean }, readonly missionProfile: { readonly __typename?: 'GsocMissionProfile', readonly missionProfileId: string, readonly missionProfileName?: string | null } };

export type GetAntennaCapabilityContactsQueryVariables = Exact<{
  groundStationName: Scalars['String']['input'];
  capabilityArn: Scalars['String']['input'];
  now: Scalars['AWSDateTime']['input'];
  terminalStatuses: ReadonlyArray<ContactStatus> | ContactStatus;
  scheduledStatuses: ReadonlyArray<ContactStatus> | ContactStatus;
}>;


export type GetAntennaCapabilityContactsQuery = { readonly __typename?: 'Query', readonly lastContact?: { readonly __typename?: 'ListGsocContactV2Output', readonly results: ReadonlyArray<{ readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly contactStatus: ContactStatus, readonly timeRange: { readonly __typename?: 'TimeRange', readonly startTime: Date, readonly endTime: Date }, readonly groundStations?: ReadonlyArray<{ readonly __typename?: 'GsocGroundStation', readonly groundStationName: string, readonly antennaName?: string | null }> | null, readonly customer: { readonly __typename?: 'GsocCustomer', readonly awsAccountId?: string | null, readonly external: boolean }, readonly missionProfile: { readonly __typename?: 'GsocMissionProfile', readonly missionProfileId: string, readonly missionProfileName?: string | null } }> } | null, readonly nextContact?: { readonly __typename?: 'ListGsocContactV2Output', readonly results: ReadonlyArray<{ readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly contactStatus: ContactStatus, readonly timeRange: { readonly __typename?: 'TimeRange', readonly startTime: Date, readonly endTime: Date }, readonly groundStations?: ReadonlyArray<{ readonly __typename?: 'GsocGroundStation', readonly groundStationName: string, readonly antennaName?: string | null }> | null, readonly customer: { readonly __typename?: 'GsocCustomer', readonly awsAccountId?: string | null, readonly external: boolean }, readonly missionProfile: { readonly __typename?: 'GsocMissionProfile', readonly missionProfileId: string, readonly missionProfileName?: string | null } }> } | null };

export type MinimalContactFragment = { readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly contactStatus: ContactStatus, readonly failedToScheduleReasons?: ReadonlyArray<string> | null, readonly telemetryRouteList?: ReadonlyArray<string> | null, readonly schedulingRegion: string, readonly destinationRegions: ReadonlyArray<string>, readonly customer: { readonly __typename?: 'GsocCustomer', readonly awsAccountId?: string | null, readonly awsGsaasAwsAccountNamePart: string, readonly external: boolean }, readonly groundStations?: ReadonlyArray<{ readonly __typename?: 'GsocGroundStation', readonly groundStationName: string, readonly antennaName?: string | null }> | null, readonly missionProfile: { readonly __typename?: 'GsocMissionProfile', readonly missionProfileArn?: string | null, readonly missionProfileId: string }, readonly satellite?: { readonly __typename?: 'GsocSatellite', readonly satelliteCatalogNumber?: number | null, readonly satelliteName?: string | null, readonly satelliteArn?: string | null } | null, readonly timeRange: { readonly __typename?: 'TimeRange', readonly startTime: Date, readonly endTime: Date } };

export type ContactFragment = { readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly contactStatus: ContactStatus, readonly failedToScheduleReasons?: ReadonlyArray<string> | null, readonly telemetryRouteList?: ReadonlyArray<string> | null, readonly schedulingRegion: string, readonly destinationRegions: ReadonlyArray<string>, readonly customer: { readonly __typename?: 'GsocCustomer', readonly awsAccountId?: string | null, readonly awsGsaasAwsAccountNamePart: string, readonly external: boolean }, readonly dataflows?: ReadonlyArray<{ readonly __typename?: 'GsocDataflowV2', readonly dataflowId: string, readonly destination: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly value: number, readonly unit: string } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null }, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string }, readonly htmlImage?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null }> } }, readonly source: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly value: number, readonly unit: string } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null }, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string }, readonly htmlImage?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null }> } } }> | null, readonly groundStations?: ReadonlyArray<{ readonly __typename?: 'GsocGroundStation', readonly groundStationName: string, readonly antennaName?: string | null }> | null, readonly missionProfile: { readonly __typename?: 'GsocMissionProfile', readonly missionProfileArn?: string | null, readonly missionProfileId: string }, readonly satellite?: { readonly __typename?: 'GsocSatellite', readonly satelliteCatalogNumber?: number | null, readonly satelliteName?: string | null, readonly satelliteArn?: string | null } | null, readonly timeRange: { readonly __typename?: 'TimeRange', readonly startTime: Date, readonly endTime: Date } };

export type DataflowFragment = { readonly __typename?: 'GsocDataflowV2', readonly dataflowId: string, readonly destination: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly value: number, readonly unit: string } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null }, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string }, readonly htmlImage?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null }> } }, readonly source: { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly value: number, readonly unit: string } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null }, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string }, readonly htmlImage?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null }> } } };

export type NodeFragment = { readonly __typename?: 'GsocNodeV2', readonly region: string, readonly config: { readonly __typename?: 'GsocConfig', readonly type: string, readonly id: string }, readonly telemetryInfo?: { readonly __typename?: 'GsocTelemetryInformation', readonly telemetryScopeId: string, readonly telemetrySourceArn: string } | null, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly dataplane?: { readonly __typename?: 'GsocNodeDataplaneDetails', readonly dataflowType?: GsocDataplaneType | null, readonly dataDefender?: { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null } | null, readonly laminarFlow?: { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null } | null } | null, readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3RecordingDetails?: { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly s3PlaybackDetails?: { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly value: number, readonly unit: string } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly connectionProxyDetails?: { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null }, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string }, readonly htmlImage?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null }> } };

export type TranslationDetailFragment = { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null };

export type RfCharacteristicsFragment = { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } };

export type DataDefenderDetailsFragment = { readonly __typename?: 'GsocNodeDataplaneDataDefenderDetails', readonly dataDeliveryServiceDestinationArn?: string | null, readonly dataDeliveryServiceSourceArn?: string | null, readonly vita49StreamId?: number | null, readonly securityDetails?: { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> } | null };

export type SecurityDetailsFragment = { readonly __typename?: 'GsocSecurityDetails', readonly roleArn?: string | null, readonly securityGroupIds: ReadonlyArray<string>, readonly subnetIds: ReadonlyArray<string> };

export type LaminarFlowDetailsFragment = { readonly __typename?: 'GsocNodeDataplaneLaminarFlowDetails', readonly egressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null, readonly ingressAddress?: { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } } | null };

export type PageInfoFragment = { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly value?: number | null, readonly relation?: Relation | null } };

export type RangedConnectionDetailsFragment = { readonly __typename?: 'GsocRangedConnectionDetails', readonly name?: string | null, readonly portRange: { readonly __typename?: 'GsocIntegerRange', readonly maximum: number, readonly minimum: number } };

export type S3RecordingDetailsFragment = { readonly __typename?: 'GsocS3RecordingDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly keyTemplate?: string | null, readonly roleArn?: string | null };

export type S3PlaybackDetailsFragment = { readonly __typename?: 'GsocS3PlaybackDetails', readonly bucketArn?: string | null, readonly bucketRegion: string, readonly roleArn?: string | null };

export type CapabilityFragment = { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly type: string, readonly arn?: string | null, readonly plots: ReadonlyArray<{ readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string }, readonly htmlImage?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null }> };

export type NamedImageV2Fragment = { readonly __typename?: 'NamedImageV2', readonly name: string, readonly image: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string }, readonly htmlImage?: { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string } | null };

export type S3ObjectFragment = { readonly __typename?: 'S3Object', readonly s3Uri: string, readonly presignedUrl: string };

export type AntennaDownlinkDetailsFragment = { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } };

export type UplinkDetailsFragment = { readonly __typename?: 'GsocUplinkDetails', readonly transmitDisabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } }, readonly targetEirp: { readonly __typename?: 'Measurement', readonly value: number, readonly unit: string } };

export type UplinkEchoDetailsFragment = { readonly __typename?: 'GsocUplinkEchoDetails', readonly enabled: boolean, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } };

export type ConnectionProxyDetailsFragment = { readonly __typename?: 'GsocConnectionProxyDetails', readonly configArn?: string | null, readonly dataflowTranslation?: { readonly __typename?: 'DataflowTranslation', readonly ingress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null, readonly egress?: { readonly __typename?: 'TranslationDetail', readonly deliveryMechanism?: DeliveryMechanism | null, readonly translationConfiguration?: { readonly __typename?: 'TranslationConfiguration', readonly type?: DeliveryMechanism | null, readonly laminarFlowConfig?: string | null, readonly vpcAttachmentDetails?: { readonly __typename?: 'VpcAttachmentDetails', readonly customerRoleArn?: string | null, readonly subnetIdList?: ReadonlyArray<string> | null, readonly securityGroupIdList?: ReadonlyArray<string> | null, readonly dataflowEndpointGroupArn?: string | null } | null } | null } | null } | null };

export type AntennaDemodDecodeDetailsFragment = { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly decodeConfigData: { readonly __typename?: 'GsocDecodeConfigData', readonly unvalidatedJson: string }, readonly demodulationConfigData: { readonly __typename?: 'GsocDemodulationConfigData', readonly unvalidatedJson: string }, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } };

export type ManagedAntennaDemodDecodeDetailsFragment = { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly managedRadioConfigId: string, readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } };

export type GsocListIamRolesQueryVariables = Exact<{
  cazJustification?: InputMaybe<Scalars['String']['input']>;
}>;


export type GsocListIamRolesQuery = { readonly __typename?: 'Query', readonly gsocListIamRoles?: { readonly __typename?: 'GsocListIamRolesOutput', readonly roles: ReadonlyArray<{ readonly __typename?: 'GsocIamRole', readonly isAuthorized: boolean, readonly name: string, readonly roleArn: string, readonly awsTemporaryCredentials?: { readonly __typename?: 'GsocAwsTemporaryCredentials', readonly accessKeyId: string, readonly expiration: Date, readonly secretAccessKey: string, readonly sessionToken: string } | null }> } | null };

export type GsocListIamRolesOutputFragment = { readonly __typename?: 'GsocListIamRolesOutput', readonly roles: ReadonlyArray<{ readonly __typename?: 'GsocIamRole', readonly isAuthorized: boolean, readonly name: string, readonly roleArn: string, readonly awsTemporaryCredentials?: { readonly __typename?: 'GsocAwsTemporaryCredentials', readonly accessKeyId: string, readonly expiration: Date, readonly secretAccessKey: string, readonly sessionToken: string } | null }> };

export type GsocIamRoleFragment = { readonly __typename?: 'GsocIamRole', readonly isAuthorized: boolean, readonly name: string, readonly roleArn: string, readonly awsTemporaryCredentials?: { readonly __typename?: 'GsocAwsTemporaryCredentials', readonly accessKeyId: string, readonly expiration: Date, readonly secretAccessKey: string, readonly sessionToken: string } | null };

export type GsocAwsTemporaryCredentialsFragment = { readonly __typename?: 'GsocAwsTemporaryCredentials', readonly accessKeyId: string, readonly expiration: Date, readonly secretAccessKey: string, readonly sessionToken: string };

export type IntrospectionQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type IntrospectionQueryQuery = { readonly __typename?: 'Query', readonly __schema: { readonly __typename?: '__Schema', readonly types: ReadonlyArray<{ readonly __typename?: '__Type', readonly name?: string | null }> } };

export type ObtainContactsOnGroundstationDuringIntervalQueryVariables = Exact<{
  where: GsocContactV2FilterInput;
  cursor?: InputMaybe<ReadonlyArray<CursorPartInput> | CursorPartInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ObtainContactsOnGroundstationDuringIntervalQuery = { readonly __typename?: 'Query', readonly listContacts?: { readonly __typename?: 'ListGsocContactV2Output', readonly results: ReadonlyArray<{ readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly contactStatus: ContactStatus, readonly timeRange: { readonly __typename?: 'TimeRange', readonly endTime: Date, readonly startTime: Date }, readonly groundStations?: ReadonlyArray<{ readonly __typename?: 'GsocGroundStation', readonly groundStationName: string, readonly antennaName?: string | null }> | null, readonly satellite?: { readonly __typename?: 'GsocSatellite', readonly satelliteCatalogNumber?: number | null } | null, readonly customer: { readonly __typename?: 'GsocCustomer', readonly external: boolean }, readonly dataflows?: ReadonlyArray<{ readonly __typename?: 'GsocDataflowV2', readonly dataflowId: string, readonly source: { readonly __typename?: 'GsocNodeV2', readonly config: { readonly __typename?: 'GsocConfig', readonly id: string }, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly arn?: string | null }, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null } }, readonly destination: { readonly __typename?: 'GsocNodeV2', readonly config: { readonly __typename?: 'GsocConfig', readonly id: string }, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly arn?: string | null }, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null } } }> | null }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null } } | null };

export type TimelineNodeRfDetailsFragment = { readonly __typename?: 'GsocNodeV2', readonly config: { readonly __typename?: 'GsocConfig', readonly id: string }, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly arn?: string | null }, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null } };

export type ContactTimelineDataFragment = { readonly __typename?: 'GsocContactV2', readonly contactId: string, readonly contactStatus: ContactStatus, readonly timeRange: { readonly __typename?: 'TimeRange', readonly endTime: Date, readonly startTime: Date }, readonly groundStations?: ReadonlyArray<{ readonly __typename?: 'GsocGroundStation', readonly groundStationName: string, readonly antennaName?: string | null }> | null, readonly satellite?: { readonly __typename?: 'GsocSatellite', readonly satelliteCatalogNumber?: number | null } | null, readonly customer: { readonly __typename?: 'GsocCustomer', readonly external: boolean }, readonly dataflows?: ReadonlyArray<{ readonly __typename?: 'GsocDataflowV2', readonly dataflowId: string, readonly source: { readonly __typename?: 'GsocNodeV2', readonly config: { readonly __typename?: 'GsocConfig', readonly id: string }, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly arn?: string | null }, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null } }, readonly destination: { readonly __typename?: 'GsocNodeV2', readonly config: { readonly __typename?: 'GsocConfig', readonly id: string }, readonly capability: { readonly __typename?: 'GsocCapabilityV2', readonly id: string, readonly arn?: string | null }, readonly nodeDetails: { readonly __typename?: 'GsocNodeDetails', readonly orchestration?: { readonly __typename?: 'GsocNodeOrchestrationDetails', readonly antennaDownlinkDetails?: { readonly __typename?: 'GsocAntennaDownlinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly antennaDemodDecodeDetails?: { readonly __typename?: 'GsocAntennaDemodDecodeDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly uplinkDetails?: { readonly __typename?: 'GsocUplinkDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly uplinkEchoDetails?: { readonly __typename?: 'GsocUplinkEchoDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null, readonly managedAntennaDemodDecodeDetails?: { readonly __typename?: 'GsocManagedAntennaDemodDecodeDetails', readonly rfCharacteristics: { readonly __typename?: 'GsocRfCharacteristics', readonly polarization: Polarization, readonly bandwidth?: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } | null, readonly centerFrequency: { readonly __typename?: 'Measurement', readonly unit: string, readonly value: number } } } | null } | null } } }> | null };

export type GetUserPermissionClaimsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPermissionClaimsQuery = { readonly __typename?: 'Query', readonly getUserPermissionClaims: ReadonlyArray<string> };

export const SecurityDetailsFragmentDoc = gql`
    fragment SecurityDetails on GsocSecurityDetails {
  roleArn
  securityGroupIds
  subnetIds
}
    `;
export const DataDefenderDetailsFragmentDoc = gql`
    fragment DataDefenderDetails on GsocNodeDataplaneDataDefenderDetails {
  securityDetails {
    ...SecurityDetails
  }
  dataDeliveryServiceDestinationArn
  dataDeliveryServiceSourceArn
  vita49StreamId
}
    ${SecurityDetailsFragmentDoc}`;
export const RangedConnectionDetailsFragmentDoc = gql`
    fragment RangedConnectionDetails on GsocRangedConnectionDetails {
  name
  portRange {
    maximum
    minimum
  }
}
    `;
export const LaminarFlowDetailsFragmentDoc = gql`
    fragment LaminarFlowDetails on GsocNodeDataplaneLaminarFlowDetails {
  egressAddress {
    ...RangedConnectionDetails
  }
  ingressAddress {
    ...RangedConnectionDetails
  }
}
    ${RangedConnectionDetailsFragmentDoc}`;
export const RfCharacteristicsFragmentDoc = gql`
    fragment RfCharacteristics on GsocRfCharacteristics {
  bandwidth {
    unit
    value
  }
  centerFrequency {
    unit
    value
  }
  polarization
}
    `;
export const AntennaDownlinkDetailsFragmentDoc = gql`
    fragment AntennaDownlinkDetails on GsocAntennaDownlinkDetails {
  rfCharacteristics {
    ...RfCharacteristics
  }
}
    ${RfCharacteristicsFragmentDoc}`;
export const S3RecordingDetailsFragmentDoc = gql`
    fragment S3RecordingDetails on GsocS3RecordingDetails {
  bucketArn
  bucketRegion
  keyTemplate
  roleArn
}
    `;
export const AntennaDemodDecodeDetailsFragmentDoc = gql`
    fragment AntennaDemodDecodeDetails on GsocAntennaDemodDecodeDetails {
  decodeConfigData {
    unvalidatedJson
  }
  demodulationConfigData {
    unvalidatedJson
  }
  rfCharacteristics {
    ...RfCharacteristics
  }
}
    ${RfCharacteristicsFragmentDoc}`;
export const S3PlaybackDetailsFragmentDoc = gql`
    fragment S3PlaybackDetails on GsocS3PlaybackDetails {
  bucketArn
  bucketRegion
  roleArn
}
    `;
export const UplinkDetailsFragmentDoc = gql`
    fragment UplinkDetails on GsocUplinkDetails {
  rfCharacteristics {
    ...RfCharacteristics
  }
  targetEirp {
    value
    unit
  }
  transmitDisabled
}
    ${RfCharacteristicsFragmentDoc}`;
export const UplinkEchoDetailsFragmentDoc = gql`
    fragment UplinkEchoDetails on GsocUplinkEchoDetails {
  rfCharacteristics {
    ...RfCharacteristics
  }
  enabled
}
    ${RfCharacteristicsFragmentDoc}`;
export const TranslationDetailFragmentDoc = gql`
    fragment TranslationDetail on TranslationDetail {
  deliveryMechanism
  translationConfiguration {
    type
    laminarFlowConfig
    vpcAttachmentDetails {
      customerRoleArn
      subnetIdList
      securityGroupIdList
      dataflowEndpointGroupArn
    }
  }
}
    `;
export const ConnectionProxyDetailsFragmentDoc = gql`
    fragment ConnectionProxyDetails on GsocConnectionProxyDetails {
  configArn
  dataflowTranslation {
    ingress {
      ...TranslationDetail
    }
    egress {
      ...TranslationDetail
    }
  }
}
    ${TranslationDetailFragmentDoc}`;
export const ManagedAntennaDemodDecodeDetailsFragmentDoc = gql`
    fragment ManagedAntennaDemodDecodeDetails on GsocManagedAntennaDemodDecodeDetails {
  rfCharacteristics {
    ...RfCharacteristics
  }
  managedRadioConfigId
}
    ${RfCharacteristicsFragmentDoc}`;
export const S3ObjectFragmentDoc = gql`
    fragment S3Object on S3Object {
  s3Uri
  presignedUrl
}
    `;
export const NamedImageV2FragmentDoc = gql`
    fragment NamedImageV2 on NamedImageV2 {
  image {
    ...S3Object
  }
  htmlImage {
    ...S3Object
  }
  name
}
    ${S3ObjectFragmentDoc}`;
export const CapabilityFragmentDoc = gql`
    fragment Capability on GsocCapabilityV2 {
  id
  type
  arn
  plots {
    ...NamedImageV2
  }
}
    ${NamedImageV2FragmentDoc}`;
export const NodeFragmentDoc = gql`
    fragment Node on GsocNodeV2 {
  config {
    type
    id
  }
  region
  telemetryInfo {
    telemetryScopeId
    telemetrySourceArn
  }
  nodeDetails {
    dataplane {
      dataflowType
      dataDefender {
        ...DataDefenderDetails
      }
      laminarFlow {
        ...LaminarFlowDetails
      }
    }
    orchestration {
      antennaDownlinkDetails {
        ...AntennaDownlinkDetails
      }
      s3RecordingDetails {
        ...S3RecordingDetails
      }
      antennaDemodDecodeDetails {
        ...AntennaDemodDecodeDetails
      }
      s3PlaybackDetails {
        ...S3PlaybackDetails
      }
      uplinkDetails {
        ...UplinkDetails
      }
      uplinkEchoDetails {
        ...UplinkEchoDetails
      }
      connectionProxyDetails {
        ...ConnectionProxyDetails
      }
      managedAntennaDemodDecodeDetails {
        ...ManagedAntennaDemodDecodeDetails
      }
    }
  }
  capability {
    ...Capability
  }
}
    ${DataDefenderDetailsFragmentDoc}
${LaminarFlowDetailsFragmentDoc}
${AntennaDownlinkDetailsFragmentDoc}
${S3RecordingDetailsFragmentDoc}
${AntennaDemodDecodeDetailsFragmentDoc}
${S3PlaybackDetailsFragmentDoc}
${UplinkDetailsFragmentDoc}
${UplinkEchoDetailsFragmentDoc}
${ConnectionProxyDetailsFragmentDoc}
${ManagedAntennaDemodDecodeDetailsFragmentDoc}
${CapabilityFragmentDoc}`;
export const DataflowFragmentDoc = gql`
    fragment Dataflow on GsocDataflowV2 {
  dataflowId
  destination {
    ...Node
  }
  source {
    ...Node
  }
}
    ${NodeFragmentDoc}`;
export const DataflowImagesFragmentDoc = gql`
    fragment DataflowImages on GsocDataflowV2 {
  destination {
    ...Node
    capability {
      ...Capability
      plots {
        ...NamedImageV2
      }
    }
  }
  source {
    ...Node
    capability {
      ...Capability
      plots {
        ...NamedImageV2
      }
    }
  }
}
    ${NodeFragmentDoc}
${CapabilityFragmentDoc}
${NamedImageV2FragmentDoc}`;
export const ContactImagesFragmentDoc = gql`
    fragment ContactImages on GsocContactV2 {
  dataflows {
    ...Dataflow
    ...DataflowImages
  }
  acuPlots {
    ...S3Object
  }
  contactPlots {
    ...NamedImageV2
  }
}
    ${DataflowFragmentDoc}
${DataflowImagesFragmentDoc}
${S3ObjectFragmentDoc}
${NamedImageV2FragmentDoc}`;
export const AntennaCapabilityContactSummaryFragmentDoc = gql`
    fragment AntennaCapabilityContactSummary on GsocContactV2 {
  contactId
  contactStatus
  timeRange {
    startTime
    endTime
  }
  groundStations {
    groundStationName
    antennaName
  }
  customer {
    awsAccountId
    external
  }
  missionProfile {
    missionProfileId
    missionProfileName
  }
}
    `;
export const MinimalContactFragmentDoc = gql`
    fragment MinimalContact on GsocContactV2 {
  contactId
  contactStatus
  customer {
    awsAccountId
    awsGsaasAwsAccountNamePart
    external
  }
  failedToScheduleReasons
  groundStations {
    groundStationName
    antennaName
  }
  missionProfile {
    missionProfileArn
    missionProfileId
  }
  telemetryRouteList
  satellite {
    satelliteCatalogNumber
    satelliteName
    satelliteArn
  }
  timeRange {
    startTime
    endTime
  }
  schedulingRegion
  destinationRegions
}
    `;
export const ContactFragmentDoc = gql`
    fragment Contact on GsocContactV2 {
  contactId
  contactStatus
  customer {
    awsAccountId
    awsGsaasAwsAccountNamePart
    external
  }
  dataflows {
    ...Dataflow
  }
  failedToScheduleReasons
  groundStations {
    groundStationName
    antennaName
  }
  missionProfile {
    missionProfileArn
    missionProfileId
  }
  satellite {
    satelliteCatalogNumber
    satelliteName
    satelliteArn
  }
  telemetryRouteList
  timeRange {
    startTime
    endTime
  }
  schedulingRegion
  destinationRegions
}
    ${DataflowFragmentDoc}`;
export const PageInfoFragmentDoc = gql`
    fragment PageInfo on PageInfo {
  lastCursor {
    key
    value
  }
  hasNextPage
  total {
    value
    relation
  }
}
    `;
export const GsocAwsTemporaryCredentialsFragmentDoc = gql`
    fragment GsocAwsTemporaryCredentials on GsocAwsTemporaryCredentials {
  accessKeyId
  expiration
  secretAccessKey
  sessionToken
}
    `;
export const GsocIamRoleFragmentDoc = gql`
    fragment GsocIamRole on GsocIamRole {
  isAuthorized
  name
  roleArn
  awsTemporaryCredentials {
    ...GsocAwsTemporaryCredentials
  }
}
    ${GsocAwsTemporaryCredentialsFragmentDoc}`;
export const GsocListIamRolesOutputFragmentDoc = gql`
    fragment GsocListIamRolesOutput on GsocListIamRolesOutput {
  roles {
    ...GsocIamRole
  }
}
    ${GsocIamRoleFragmentDoc}`;
export const TimelineNodeRfDetailsFragmentDoc = gql`
    fragment TimelineNodeRfDetails on GsocNodeV2 {
  config {
    id
  }
  capability {
    id
    arn
  }
  nodeDetails {
    orchestration {
      antennaDownlinkDetails {
        rfCharacteristics {
          ...RfCharacteristics
        }
      }
      antennaDemodDecodeDetails {
        rfCharacteristics {
          ...RfCharacteristics
        }
      }
      uplinkDetails {
        rfCharacteristics {
          ...RfCharacteristics
        }
      }
      uplinkEchoDetails {
        rfCharacteristics {
          ...RfCharacteristics
        }
      }
      managedAntennaDemodDecodeDetails {
        rfCharacteristics {
          ...RfCharacteristics
        }
      }
    }
  }
}
    ${RfCharacteristicsFragmentDoc}`;
export const ContactTimelineDataFragmentDoc = gql`
    fragment ContactTimelineData on GsocContactV2 {
  contactId
  contactStatus
  timeRange {
    endTime
    startTime
  }
  groundStations {
    groundStationName
    antennaName
  }
  satellite {
    satelliteCatalogNumber
  }
  customer {
    external
  }
  dataflows {
    dataflowId
    source {
      ...TimelineNodeRfDetails
    }
    destination {
      ...TimelineNodeRfDetails
    }
  }
}
    ${TimelineNodeRfDetailsFragmentDoc}`;
export const ListContactsDocument = gql`
    query listContacts($input: ListGsocContactV2Input!) {
  listContacts: listGsocContactV2(input: $input) {
    results {
      ...MinimalContact
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${MinimalContactFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useListContactsQuery__
 *
 * To run a query within a React component, call `useListContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListContactsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useListContactsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListContactsQuery, ListContactsQueryVariables> & ({ variables: ListContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListContactsQuery, ListContactsQueryVariables>(ListContactsDocument, options);
      }
export function useListContactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListContactsQuery, ListContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListContactsQuery, ListContactsQueryVariables>(ListContactsDocument, options);
        }
// @ts-ignore
export function useListContactsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ListContactsQuery, ListContactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ListContactsQuery, ListContactsQueryVariables>;
export function useListContactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ListContactsQuery, ListContactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ListContactsQuery | undefined, ListContactsQueryVariables>;
export function useListContactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ListContactsQuery, ListContactsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ListContactsQuery, ListContactsQueryVariables>(ListContactsDocument, options);
        }
export type ListContactsQueryHookResult = ReturnType<typeof useListContactsQuery>;
export type ListContactsLazyQueryHookResult = ReturnType<typeof useListContactsLazyQuery>;
export type ListContactsSuspenseQueryHookResult = ReturnType<typeof useListContactsSuspenseQuery>;
export type ListContactsQueryResult = Apollo.QueryResult<ListContactsQuery, ListContactsQueryVariables>;
export const GetStatisticInformationForContactDocument = gql`
    query getStatisticInformationForContact($awsAccountId: String!, $satelliteId: String, $missionProfileArn: String!, $groundStationName: String!, $startTime: AWSDateTime!, $endTime: AWSDateTime!) {
  missionProfileCompleted: listGsocContactV2(
    input: {where: {contactStatus: {_eq: COMPLETED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, missionProfile: {missionProfileArn: {_eq: $missionProfileArn}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  missionProfileFailed: listGsocContactV2(
    input: {where: {contactStatus: {_eq: FAILED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, missionProfile: {missionProfileArn: {_eq: $missionProfileArn}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  missionProfileAwsFailed: listGsocContactV2(
    input: {where: {contactStatus: {_eq: AWS_FAILED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, missionProfile: {missionProfileArn: {_eq: $missionProfileArn}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  missionProfileCancelled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: CANCELLED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, missionProfile: {missionProfileArn: {_eq: $missionProfileArn}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  missionProfileAwsCancelled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: AWS_CANCELLED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, missionProfile: {missionProfileArn: {_eq: $missionProfileArn}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  missionProfileScheduled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: SCHEDULED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, missionProfile: {missionProfileArn: {_eq: $missionProfileArn}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  missionProfileFailedToSchedule: listGsocContactV2(
    input: {where: {contactStatus: {_eq: FAILED_TO_SCHEDULE}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, missionProfile: {missionProfileArn: {_eq: $missionProfileArn}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  satelliteCompleted: listGsocContactV2(
    input: {where: {contactStatus: {_eq: COMPLETED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, satellite: {satelliteArn: {_eq: $satelliteId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  satelliteFailed: listGsocContactV2(
    input: {where: {contactStatus: {_eq: FAILED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, satellite: {satelliteArn: {_eq: $satelliteId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  satelliteAwsFailed: listGsocContactV2(
    input: {where: {contactStatus: {_eq: AWS_FAILED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, satellite: {satelliteArn: {_eq: $satelliteId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  satelliteCancelled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: CANCELLED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, satellite: {satelliteArn: {_eq: $satelliteId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  satelliteAwsCancelled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: AWS_CANCELLED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, satellite: {satelliteArn: {_eq: $satelliteId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  satelliteScheduled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: SCHEDULED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, satellite: {satelliteArn: {_eq: $satelliteId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  satelliteFailedToSchedule: listGsocContactV2(
    input: {where: {contactStatus: {_eq: FAILED_TO_SCHEDULE}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, satellite: {satelliteArn: {_eq: $satelliteId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  accountCompleted: listGsocContactV2(
    input: {where: {contactStatus: {_eq: COMPLETED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  accountFailed: listGsocContactV2(
    input: {where: {contactStatus: {_eq: FAILED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  accountAwsFailed: listGsocContactV2(
    input: {where: {contactStatus: {_eq: AWS_FAILED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  accountCancelled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: CANCELLED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  accountAwsCancelled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: AWS_CANCELLED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  accountScheduled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: SCHEDULED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  accountFailedToSchedule: listGsocContactV2(
    input: {where: {contactStatus: {_eq: FAILED_TO_SCHEDULE}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  groundStationCompleted: listGsocContactV2(
    input: {where: {contactStatus: {_eq: COMPLETED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, groundStations: {groundStationName: {_eq: $groundStationName}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  groundStationFailed: listGsocContactV2(
    input: {where: {contactStatus: {_eq: FAILED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, groundStations: {groundStationName: {_eq: $groundStationName}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  groundStationAwsFailed: listGsocContactV2(
    input: {where: {contactStatus: {_eq: AWS_FAILED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, groundStations: {groundStationName: {_eq: $groundStationName}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  groundStationCancelled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: CANCELLED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, groundStations: {groundStationName: {_eq: $groundStationName}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  groundStationAwsCancelled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: AWS_CANCELLED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, groundStations: {groundStationName: {_eq: $groundStationName}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  groundStationScheduled: listGsocContactV2(
    input: {where: {contactStatus: {_eq: SCHEDULED}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, groundStations: {groundStationName: {_eq: $groundStationName}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
  groundStationFailedToSchedule: listGsocContactV2(
    input: {where: {contactStatus: {_eq: FAILED_TO_SCHEDULE}, timeRange: {startTime: {_gte: $startTime}, endTime: {_lte: $endTime}}, groundStations: {groundStationName: {_eq: $groundStationName}}, customer: {awsAccountId: {_eq: $awsAccountId}}}}
  ) {
    pageInfo {
      ...PageInfo
    }
  }
}
    ${PageInfoFragmentDoc}`;

/**
 * __useGetStatisticInformationForContactQuery__
 *
 * To run a query within a React component, call `useGetStatisticInformationForContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStatisticInformationForContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStatisticInformationForContactQuery({
 *   variables: {
 *      awsAccountId: // value for 'awsAccountId'
 *      satelliteId: // value for 'satelliteId'
 *      missionProfileArn: // value for 'missionProfileArn'
 *      groundStationName: // value for 'groundStationName'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useGetStatisticInformationForContactQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetStatisticInformationForContactQuery, GetStatisticInformationForContactQueryVariables> & ({ variables: GetStatisticInformationForContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetStatisticInformationForContactQuery, GetStatisticInformationForContactQueryVariables>(GetStatisticInformationForContactDocument, options);
      }
export function useGetStatisticInformationForContactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStatisticInformationForContactQuery, GetStatisticInformationForContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetStatisticInformationForContactQuery, GetStatisticInformationForContactQueryVariables>(GetStatisticInformationForContactDocument, options);
        }
// @ts-ignore
export function useGetStatisticInformationForContactSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetStatisticInformationForContactQuery, GetStatisticInformationForContactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetStatisticInformationForContactQuery, GetStatisticInformationForContactQueryVariables>;
export function useGetStatisticInformationForContactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetStatisticInformationForContactQuery, GetStatisticInformationForContactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetStatisticInformationForContactQuery | undefined, GetStatisticInformationForContactQueryVariables>;
export function useGetStatisticInformationForContactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetStatisticInformationForContactQuery, GetStatisticInformationForContactQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetStatisticInformationForContactQuery, GetStatisticInformationForContactQueryVariables>(GetStatisticInformationForContactDocument, options);
        }
export type GetStatisticInformationForContactQueryHookResult = ReturnType<typeof useGetStatisticInformationForContactQuery>;
export type GetStatisticInformationForContactLazyQueryHookResult = ReturnType<typeof useGetStatisticInformationForContactLazyQuery>;
export type GetStatisticInformationForContactSuspenseQueryHookResult = ReturnType<typeof useGetStatisticInformationForContactSuspenseQuery>;
export type GetStatisticInformationForContactQueryResult = Apollo.QueryResult<GetStatisticInformationForContactQuery, GetStatisticInformationForContactQueryVariables>;
export const GetContactDocument = gql`
    query getContact($input: GetGsocContactV2Input!) {
  getContact: getGsocContactV2(input: $input) {
    ...Contact
    ...ContactImages
  }
}
    ${ContactFragmentDoc}
${ContactImagesFragmentDoc}`;

/**
 * __useGetContactQuery__
 *
 * To run a query within a React component, call `useGetContactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetContactQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetContactQuery, GetContactQueryVariables> & ({ variables: GetContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
      }
export function useGetContactLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
        }
// @ts-ignore
export function useGetContactSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetContactQuery, GetContactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetContactQuery, GetContactQueryVariables>;
export function useGetContactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetContactQuery, GetContactQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetContactQuery | undefined, GetContactQueryVariables>;
export function useGetContactSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetContactQuery, GetContactQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetContactQuery, GetContactQueryVariables>(GetContactDocument, options);
        }
export type GetContactQueryHookResult = ReturnType<typeof useGetContactQuery>;
export type GetContactLazyQueryHookResult = ReturnType<typeof useGetContactLazyQuery>;
export type GetContactSuspenseQueryHookResult = ReturnType<typeof useGetContactSuspenseQuery>;
export type GetContactQueryResult = Apollo.QueryResult<GetContactQuery, GetContactQueryVariables>;
export const GetEphemerisInfoListDocument = gql`
    query getEphemerisInfoList($contactId: String!) {
  getGsocContactV2(input: {contactId: $contactId}) {
    contactId
    ephemerisInfoList {
      ephemerisSourceType
      ephemerisId
      updateTime
      usageType
    }
  }
}
    `;

/**
 * __useGetEphemerisInfoListQuery__
 *
 * To run a query within a React component, call `useGetEphemerisInfoListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEphemerisInfoListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEphemerisInfoListQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetEphemerisInfoListQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetEphemerisInfoListQuery, GetEphemerisInfoListQueryVariables> & ({ variables: GetEphemerisInfoListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEphemerisInfoListQuery, GetEphemerisInfoListQueryVariables>(GetEphemerisInfoListDocument, options);
      }
export function useGetEphemerisInfoListLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEphemerisInfoListQuery, GetEphemerisInfoListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEphemerisInfoListQuery, GetEphemerisInfoListQueryVariables>(GetEphemerisInfoListDocument, options);
        }
// @ts-ignore
export function useGetEphemerisInfoListSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetEphemerisInfoListQuery, GetEphemerisInfoListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEphemerisInfoListQuery, GetEphemerisInfoListQueryVariables>;
export function useGetEphemerisInfoListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEphemerisInfoListQuery, GetEphemerisInfoListQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetEphemerisInfoListQuery | undefined, GetEphemerisInfoListQueryVariables>;
export function useGetEphemerisInfoListSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEphemerisInfoListQuery, GetEphemerisInfoListQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEphemerisInfoListQuery, GetEphemerisInfoListQueryVariables>(GetEphemerisInfoListDocument, options);
        }
export type GetEphemerisInfoListQueryHookResult = ReturnType<typeof useGetEphemerisInfoListQuery>;
export type GetEphemerisInfoListLazyQueryHookResult = ReturnType<typeof useGetEphemerisInfoListLazyQuery>;
export type GetEphemerisInfoListSuspenseQueryHookResult = ReturnType<typeof useGetEphemerisInfoListSuspenseQuery>;
export type GetEphemerisInfoListQueryResult = Apollo.QueryResult<GetEphemerisInfoListQuery, GetEphemerisInfoListQueryVariables>;
export const GetSignatureMapDocument = gql`
    query getSignatureMap($contactId: String!) {
  getGsocContactV2(input: {contactId: $contactId}) {
    contactId
    signatureMap {
      key
      value
    }
  }
}
    `;

/**
 * __useGetSignatureMapQuery__
 *
 * To run a query within a React component, call `useGetSignatureMapQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignatureMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignatureMapQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useGetSignatureMapQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetSignatureMapQuery, GetSignatureMapQueryVariables> & ({ variables: GetSignatureMapQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetSignatureMapQuery, GetSignatureMapQueryVariables>(GetSignatureMapDocument, options);
      }
export function useGetSignatureMapLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetSignatureMapQuery, GetSignatureMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetSignatureMapQuery, GetSignatureMapQueryVariables>(GetSignatureMapDocument, options);
        }
// @ts-ignore
export function useGetSignatureMapSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetSignatureMapQuery, GetSignatureMapQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSignatureMapQuery, GetSignatureMapQueryVariables>;
export function useGetSignatureMapSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSignatureMapQuery, GetSignatureMapQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetSignatureMapQuery | undefined, GetSignatureMapQueryVariables>;
export function useGetSignatureMapSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetSignatureMapQuery, GetSignatureMapQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetSignatureMapQuery, GetSignatureMapQueryVariables>(GetSignatureMapDocument, options);
        }
export type GetSignatureMapQueryHookResult = ReturnType<typeof useGetSignatureMapQuery>;
export type GetSignatureMapLazyQueryHookResult = ReturnType<typeof useGetSignatureMapLazyQuery>;
export type GetSignatureMapSuspenseQueryHookResult = ReturnType<typeof useGetSignatureMapSuspenseQuery>;
export type GetSignatureMapQueryResult = Apollo.QueryResult<GetSignatureMapQuery, GetSignatureMapQueryVariables>;
export const GetAntennaCapabilityContactsDocument = gql`
    query getAntennaCapabilityContacts($groundStationName: String!, $capabilityArn: String!, $now: AWSDateTime!, $terminalStatuses: [ContactStatus!]!, $scheduledStatuses: [ContactStatus!]!) {
  lastContact: listGsocContactV2(
    input: {where: {groundStations: {groundStationName: {_eq: $groundStationName}}, _or: [{dataflows: {source: {capability: {arn: {_eq: $capabilityArn}}}}}, {dataflows: {destination: {capability: {arn: {_eq: $capabilityArn}}}}}], contactStatus: {_in: $terminalStatuses}, timeRange: {endTime: {_lte: $now}}}, sort: [{timeRange: {endTime: desc}}], limit: 1}
  ) {
    results {
      ...AntennaCapabilityContactSummary
    }
  }
  nextContact: listGsocContactV2(
    input: {where: {groundStations: {groundStationName: {_eq: $groundStationName}}, _or: [{dataflows: {source: {capability: {arn: {_eq: $capabilityArn}}}}}, {dataflows: {destination: {capability: {arn: {_eq: $capabilityArn}}}}}], contactStatus: {_in: $scheduledStatuses}, timeRange: {startTime: {_gte: $now}}}, sort: [{timeRange: {startTime: asc}}], limit: 1}
  ) {
    results {
      ...AntennaCapabilityContactSummary
    }
  }
}
    ${AntennaCapabilityContactSummaryFragmentDoc}`;

/**
 * __useGetAntennaCapabilityContactsQuery__
 *
 * To run a query within a React component, call `useGetAntennaCapabilityContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAntennaCapabilityContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAntennaCapabilityContactsQuery({
 *   variables: {
 *      groundStationName: // value for 'groundStationName'
 *      capabilityArn: // value for 'capabilityArn'
 *      now: // value for 'now'
 *      terminalStatuses: // value for 'terminalStatuses'
 *      scheduledStatuses: // value for 'scheduledStatuses'
 *   },
 * });
 */
export function useGetAntennaCapabilityContactsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAntennaCapabilityContactsQuery, GetAntennaCapabilityContactsQueryVariables> & ({ variables: GetAntennaCapabilityContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAntennaCapabilityContactsQuery, GetAntennaCapabilityContactsQueryVariables>(GetAntennaCapabilityContactsDocument, options);
      }
export function useGetAntennaCapabilityContactsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAntennaCapabilityContactsQuery, GetAntennaCapabilityContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAntennaCapabilityContactsQuery, GetAntennaCapabilityContactsQueryVariables>(GetAntennaCapabilityContactsDocument, options);
        }
// @ts-ignore
export function useGetAntennaCapabilityContactsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetAntennaCapabilityContactsQuery, GetAntennaCapabilityContactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAntennaCapabilityContactsQuery, GetAntennaCapabilityContactsQueryVariables>;
export function useGetAntennaCapabilityContactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAntennaCapabilityContactsQuery, GetAntennaCapabilityContactsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetAntennaCapabilityContactsQuery | undefined, GetAntennaCapabilityContactsQueryVariables>;
export function useGetAntennaCapabilityContactsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAntennaCapabilityContactsQuery, GetAntennaCapabilityContactsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAntennaCapabilityContactsQuery, GetAntennaCapabilityContactsQueryVariables>(GetAntennaCapabilityContactsDocument, options);
        }
export type GetAntennaCapabilityContactsQueryHookResult = ReturnType<typeof useGetAntennaCapabilityContactsQuery>;
export type GetAntennaCapabilityContactsLazyQueryHookResult = ReturnType<typeof useGetAntennaCapabilityContactsLazyQuery>;
export type GetAntennaCapabilityContactsSuspenseQueryHookResult = ReturnType<typeof useGetAntennaCapabilityContactsSuspenseQuery>;
export type GetAntennaCapabilityContactsQueryResult = Apollo.QueryResult<GetAntennaCapabilityContactsQuery, GetAntennaCapabilityContactsQueryVariables>;
export const GsocListIamRolesDocument = gql`
    query gsocListIamRoles($cazJustification: String) {
  gsocListIamRoles(cazJustification: $cazJustification) {
    ...GsocListIamRolesOutput
  }
}
    ${GsocListIamRolesOutputFragmentDoc}`;

/**
 * __useGsocListIamRolesQuery__
 *
 * To run a query within a React component, call `useGsocListIamRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGsocListIamRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGsocListIamRolesQuery({
 *   variables: {
 *      cazJustification: // value for 'cazJustification'
 *   },
 * });
 */
export function useGsocListIamRolesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GsocListIamRolesQuery, GsocListIamRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GsocListIamRolesQuery, GsocListIamRolesQueryVariables>(GsocListIamRolesDocument, options);
      }
export function useGsocListIamRolesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GsocListIamRolesQuery, GsocListIamRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GsocListIamRolesQuery, GsocListIamRolesQueryVariables>(GsocListIamRolesDocument, options);
        }
// @ts-ignore
export function useGsocListIamRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GsocListIamRolesQuery, GsocListIamRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GsocListIamRolesQuery, GsocListIamRolesQueryVariables>;
export function useGsocListIamRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GsocListIamRolesQuery, GsocListIamRolesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GsocListIamRolesQuery | undefined, GsocListIamRolesQueryVariables>;
export function useGsocListIamRolesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GsocListIamRolesQuery, GsocListIamRolesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GsocListIamRolesQuery, GsocListIamRolesQueryVariables>(GsocListIamRolesDocument, options);
        }
export type GsocListIamRolesQueryHookResult = ReturnType<typeof useGsocListIamRolesQuery>;
export type GsocListIamRolesLazyQueryHookResult = ReturnType<typeof useGsocListIamRolesLazyQuery>;
export type GsocListIamRolesSuspenseQueryHookResult = ReturnType<typeof useGsocListIamRolesSuspenseQuery>;
export type GsocListIamRolesQueryResult = Apollo.QueryResult<GsocListIamRolesQuery, GsocListIamRolesQueryVariables>;
export const IntrospectionQueryDocument = gql`
    query IntrospectionQuery {
  __schema {
    types {
      name
    }
  }
}
    `;

/**
 * __useIntrospectionQueryQuery__
 *
 * To run a query within a React component, call `useIntrospectionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntrospectionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntrospectionQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntrospectionQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IntrospectionQueryQuery, IntrospectionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IntrospectionQueryQuery, IntrospectionQueryQueryVariables>(IntrospectionQueryDocument, options);
      }
export function useIntrospectionQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IntrospectionQueryQuery, IntrospectionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IntrospectionQueryQuery, IntrospectionQueryQueryVariables>(IntrospectionQueryDocument, options);
        }
// @ts-ignore
export function useIntrospectionQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<IntrospectionQueryQuery, IntrospectionQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IntrospectionQueryQuery, IntrospectionQueryQueryVariables>;
export function useIntrospectionQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IntrospectionQueryQuery, IntrospectionQueryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IntrospectionQueryQuery | undefined, IntrospectionQueryQueryVariables>;
export function useIntrospectionQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IntrospectionQueryQuery, IntrospectionQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IntrospectionQueryQuery, IntrospectionQueryQueryVariables>(IntrospectionQueryDocument, options);
        }
export type IntrospectionQueryQueryHookResult = ReturnType<typeof useIntrospectionQueryQuery>;
export type IntrospectionQueryLazyQueryHookResult = ReturnType<typeof useIntrospectionQueryLazyQuery>;
export type IntrospectionQuerySuspenseQueryHookResult = ReturnType<typeof useIntrospectionQuerySuspenseQuery>;
export type IntrospectionQueryQueryResult = Apollo.QueryResult<IntrospectionQueryQuery, IntrospectionQueryQueryVariables>;
export const ObtainContactsOnGroundstationDuringIntervalDocument = gql`
    query ObtainContactsOnGroundstationDuringInterval($where: GsocContactV2FilterInput!, $cursor: [CursorPartInput!], $limit: Int) {
  listContacts: listGsocContactV2(
    input: {limit: $limit, where: $where, sort: {timeRange: {startTime: asc}}, cursor: $cursor}
  ) {
    results {
      ...ContactTimelineData
    }
    pageInfo {
      hasNextPage
      lastCursor {
        key
        value
      }
    }
  }
}
    ${ContactTimelineDataFragmentDoc}`;

/**
 * __useObtainContactsOnGroundstationDuringIntervalQuery__
 *
 * To run a query within a React component, call `useObtainContactsOnGroundstationDuringIntervalQuery` and pass it any options that fit your needs.
 * When your component renders, `useObtainContactsOnGroundstationDuringIntervalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObtainContactsOnGroundstationDuringIntervalQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useObtainContactsOnGroundstationDuringIntervalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ObtainContactsOnGroundstationDuringIntervalQuery, ObtainContactsOnGroundstationDuringIntervalQueryVariables> & ({ variables: ObtainContactsOnGroundstationDuringIntervalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ObtainContactsOnGroundstationDuringIntervalQuery, ObtainContactsOnGroundstationDuringIntervalQueryVariables>(ObtainContactsOnGroundstationDuringIntervalDocument, options);
      }
export function useObtainContactsOnGroundstationDuringIntervalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ObtainContactsOnGroundstationDuringIntervalQuery, ObtainContactsOnGroundstationDuringIntervalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ObtainContactsOnGroundstationDuringIntervalQuery, ObtainContactsOnGroundstationDuringIntervalQueryVariables>(ObtainContactsOnGroundstationDuringIntervalDocument, options);
        }
// @ts-ignore
export function useObtainContactsOnGroundstationDuringIntervalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ObtainContactsOnGroundstationDuringIntervalQuery, ObtainContactsOnGroundstationDuringIntervalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ObtainContactsOnGroundstationDuringIntervalQuery, ObtainContactsOnGroundstationDuringIntervalQueryVariables>;
export function useObtainContactsOnGroundstationDuringIntervalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ObtainContactsOnGroundstationDuringIntervalQuery, ObtainContactsOnGroundstationDuringIntervalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ObtainContactsOnGroundstationDuringIntervalQuery | undefined, ObtainContactsOnGroundstationDuringIntervalQueryVariables>;
export function useObtainContactsOnGroundstationDuringIntervalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ObtainContactsOnGroundstationDuringIntervalQuery, ObtainContactsOnGroundstationDuringIntervalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ObtainContactsOnGroundstationDuringIntervalQuery, ObtainContactsOnGroundstationDuringIntervalQueryVariables>(ObtainContactsOnGroundstationDuringIntervalDocument, options);
        }
export type ObtainContactsOnGroundstationDuringIntervalQueryHookResult = ReturnType<typeof useObtainContactsOnGroundstationDuringIntervalQuery>;
export type ObtainContactsOnGroundstationDuringIntervalLazyQueryHookResult = ReturnType<typeof useObtainContactsOnGroundstationDuringIntervalLazyQuery>;
export type ObtainContactsOnGroundstationDuringIntervalSuspenseQueryHookResult = ReturnType<typeof useObtainContactsOnGroundstationDuringIntervalSuspenseQuery>;
export type ObtainContactsOnGroundstationDuringIntervalQueryResult = Apollo.QueryResult<ObtainContactsOnGroundstationDuringIntervalQuery, ObtainContactsOnGroundstationDuringIntervalQueryVariables>;
export const GetUserPermissionClaimsDocument = gql`
    query getUserPermissionClaims {
  getUserPermissionClaims
}
    `;

/**
 * __useGetUserPermissionClaimsQuery__
 *
 * To run a query within a React component, call `useGetUserPermissionClaimsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPermissionClaimsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPermissionClaimsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPermissionClaimsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserPermissionClaimsQuery, GetUserPermissionClaimsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserPermissionClaimsQuery, GetUserPermissionClaimsQueryVariables>(GetUserPermissionClaimsDocument, options);
      }
export function useGetUserPermissionClaimsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserPermissionClaimsQuery, GetUserPermissionClaimsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserPermissionClaimsQuery, GetUserPermissionClaimsQueryVariables>(GetUserPermissionClaimsDocument, options);
        }
// @ts-ignore
export function useGetUserPermissionClaimsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserPermissionClaimsQuery, GetUserPermissionClaimsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserPermissionClaimsQuery, GetUserPermissionClaimsQueryVariables>;
export function useGetUserPermissionClaimsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserPermissionClaimsQuery, GetUserPermissionClaimsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserPermissionClaimsQuery | undefined, GetUserPermissionClaimsQueryVariables>;
export function useGetUserPermissionClaimsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserPermissionClaimsQuery, GetUserPermissionClaimsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserPermissionClaimsQuery, GetUserPermissionClaimsQueryVariables>(GetUserPermissionClaimsDocument, options);
        }
export type GetUserPermissionClaimsQueryHookResult = ReturnType<typeof useGetUserPermissionClaimsQuery>;
export type GetUserPermissionClaimsLazyQueryHookResult = ReturnType<typeof useGetUserPermissionClaimsLazyQuery>;
export type GetUserPermissionClaimsSuspenseQueryHookResult = ReturnType<typeof useGetUserPermissionClaimsSuspenseQuery>;
export type GetUserPermissionClaimsQueryResult = Apollo.QueryResult<GetUserPermissionClaimsQuery, GetUserPermissionClaimsQueryVariables>;